// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#root,
.app,
body,
html {
    font-family: Inter, sans-serif;
    height: 100%;
    width: 100%
}

::-webkit-scrollbar {
    width: 10px
}

::-webkit-scrollbar-track {
    background: #7a7f9d
}

::-webkit-scrollbar-thumb,
::-webkit-scrollbar-track:hover {
    background: #21295c
}

.borderless-table {
    border-collapse: collapse;
    width: 100%
}

.borderless-table td,
.borderless-table th {
    border: 1px solid #000;
    padding: 8px
}

.borderless-table {
    border-left: none;
    border-right: none
}

.mg20 {
    margin: 20px
}

.mb25 {
    margin-bottom: 25px
}

.container2 {
    margin: auto;
    position: relative;
    width: 600px
}

.btn-upload {
    position: absolute !important;
    right: 10px
}

.file-name {
    display: inline-block;
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    white-space: nowrap
}

.list-group {
    margin: 0;
    padding: 0
}

.list-header {
    margin-top: 10px !important
}

.upload-message {
    color: #63a84e;
    font-weight: 700;
    margin-top: 20px !important
}

.upload-message.error {
    color: #da4148
}

.btn-choose {
    margin-right: 10px !important
}

.borderless-table td:first-child,
.borderless-table th:first-child {
    border-left: none
}

.borderless-table td:last-child,
.borderless-table th:last-child {
    border-right: none
}

.card {
    margin: auto;
    opacity: 97%;
    width: 700px
}

.card2 {
    width: 1000px
}

.guestName {
    font-size: 40px
}

.reservationInfo {
    font-size: 16.6px
}

.selectRadio {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-bottom: 10px;
    margin-top: 20px
}

.represent {
    font-size: 23.4px;
    margin-right: 30px;
    white-space: nowrap
}

.isIndividual {
    font-size: 20px;
}

.formControl {
    display: flex;
    flex-direction: row
}

.inputLabel {
    font-size: 20px;
    margin-right: 15px;
    margin-top: 7px;
    white-space: nowrap
}

.inputFieldItem {
    height: 37px;
    justify-content: space-between;
    margin-right: 20px
}

.inputCountrySelect,
.inputFieldItem {
    display: flex;
    flex-direction: row;
    margin-left: 20px;
    margin-top: 15px
}

.vatFieldDirection {
    display: flex;
    flex-direction: row;
    justify-content: space-between
}

.declareText {
    font-size: 26px;
    margin-top: 10px
}

.totalMoney {
    font-size: 32px;
    margin-top: 10px;
    text-align: center
}

.finalButtonField {
    display: flex;
    justify-content: center;
    margin-top: 25px
}

.finalButton {
    font-family: -apple-system;
    font-size: 30px;
    text-align: center
}

.errorCard {
    align-content: center;
    font-size: 30px;
    height: 200px;
    margin: 200px auto auto;
    width: 700px
}

.rentalAgreement {
    cursor: pointer;
    font-size: 22px
}

.Modal {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    z-index: 1000;
    align-items: center;
}

.Modal-Background {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: #000;
    background-color: #0006;
    z-index: 1000;
}

.Modal-Content {
    background-color: #fefefe;
    border: 1px solid #888;
    border-radius: .3rem;
    margin: 300px auto auto;
    padding: 20px;
    position: relative;
    width: 40%;
    z-index: 1050;
}

.Modal-Body {
    flex: 1 1 auto;
    padding: 1rem;
    position: relative
}

.Modal-Footer {
    align-items: center;
    border-bottom-left-radius: calc(.3rem - 1px);
    border-bottom-right-radius: calc(.3rem - 1px);
    border-top: 1px solid #dee2e6;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    padding: .75rem
}

.Modal-Header {
    align-items: flex-start;
    border-bottom: 1px solid #dee2e6;
    border-top-left-radius: calc(-1px + .3rem);
    border-top-right-radius: calc(-1px + .3rem);
    display: flex;
    justify-content: end
}

.Close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: 700
}

.Close:focus,
.Close:hover {
    color: #000;
    cursor: pointer;
    text-decoration: none
}

@media screen and (max-width:1000px) {
    .Modal-Content {
        width: 95%
    }
    .rentalAgreement {
        font-size: 18px
    }
    .errorCard {
        align-content: center;
        font-size: 20px;
        height: 130px;
        margin: 200px auto auto;
        width: 100%
    }
    .background {
        background-repeat: repeat-y;
        padding: 15px
    }
    .card,
    .card2 {
        width: 100%
    }
    .guestName {
        font-size: 26px
    }
    .reservationInfo {
        font-size: 14px
    }
    .represent {
        font-size: 18px;
        margin: auto;
        white-space: nowrap
    }
    .isIndividual {
        font-size: 15px
    }
    .formControl {
        display: flex;
        flex-direction: column
    }
    .selectRadio {
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-bottom: -7px;
        margin-top: -7px
    }
    .inputLabel {
        font-size: 14px;
        margin-right: 10px;
        margin-top: 7px;
        white-space: nowrap
    }
    .inputFieldItem {
        justify-content: space-between;
        margin-right: 0
    }
    .inputCountrySelect,
    .inputFieldItem {
        display: flex;
        flex-direction: row;
        margin-left: 0;
        margin-top: 10px
    }
    .vatFieldDirection {
        display: flex;
        flex-direction: column;
        justify-content: space-between
    }
    .declareText {
        font-size: 17px;
        margin-top: 10px
    }
    .totalMoney {
        font-size: 24px;
        margin-top: 5px
    }
    .finalButtonField {
        display: flex;
        justify-content: center;
        margin-top: 15px
    }
    .finalButton {
        font-family: -apple-system;
        font-size: 20px;
        text-align: center
    }
}

.App {
    text-align: center
}

.App-logo {
    height: 40vmin;
    pointer-events: none
}

@media (prefers-reduced-motion:no-preference) {
    .App-logo {
        animation: App-logo-spin 20s linear infinite
    }
}

.App-header {
    align-items: center;
    background-color: #282c34;
    color: #fff;
    display: flex;
    flex-direction: column;
    font-size: calc(10px + 2vmin);
    justify-content: center;
    min-height: 100vh
}

.App-link {
    color: #61dafb
}

@keyframes App-logo-spin {
    0% {
        transform: rotate(0deg)
    }
    to {
        transform: rotate(1turn)
    }
}

.dropzone {
    background-color: #fafafa;
    border: 3px dashed #ccc;
    color: #bdbdbd;
    cursor: pointer;
    margin-bottom: 30px;
    padding: 70px
}

.dropzone,
.selected-file-wrapper {
    text-align: center
}

.selected-file {
    color: #000;
    font-size: 20px;
    font-weight: 700
}

:root {
    --toastify-color-light: #fff;
    --toastify-color-dark: #121212;
    --toastify-color-info: #3498db;
    --toastify-color-success: #07bc0c;
    --toastify-color-warning: #f1c40f;
    --toastify-color-error: #e74c3c;
    --toastify-color-transparent: #ffffffb3;
    --toastify-icon-color-info: var(--toastify-color-info);
    --toastify-icon-color-success: var(--toastify-color-success);
    --toastify-icon-color-warning: var(--toastify-color-warning);
    --toastify-icon-color-error: var(--toastify-color-error);
    --toastify-toast-width: 320px;
    --toastify-toast-offset: 16px;
    --toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));
    --toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));
    --toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));
    --toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));
    --toastify-toast-background: #fff;
    --toastify-toast-min-height: 64px;
    --toastify-toast-max-height: 800px;
    --toastify-toast-bd-radius: 6px;
    --toastify-font-family: sans-serif;
    --toastify-z-index: 9999;
    --toastify-text-color-light: #757575;
    --toastify-text-color-dark: #fff;
    --toastify-text-color-info: #fff;
    --toastify-text-color-success: #fff;
    --toastify-text-color-warning: #fff;
    --toastify-text-color-error: #fff;
    --toastify-spinner-color: #616161;
    --toastify-spinner-color-empty-area: #e0e0e0;
    --toastify-color-progress-light: linear-gradient(90deg, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);
    --toastify-color-progress-dark: #bb86fc;
    --toastify-color-progress-info: var(--toastify-color-info);
    --toastify-color-progress-success: var(--toastify-color-success);
    --toastify-color-progress-warning: var(--toastify-color-warning);
    --toastify-color-progress-error: var(--toastify-color-error);
    --toastify-color-progress-bgo: 0.2
}

.Toastify__toast-container {
    box-sizing: border-box;
    color: #fff;
    padding: 4px;
    position: fixed;
    -webkit-transform: translateZ(9999);
    -webkit-transform: translateZ(var(--toastify-z-index));
    width: 320px;
    width: var(--toastify-toast-width);
    z-index: 9999;
    z-index: var(--toastify-z-index)
}

.Toastify__toast-container--top-left {
    left: max(16px, env(safe-area-inset-left));
    left: var(--toastify-toast-left);
    top: max(16px, env(safe-area-inset-top));
    top: var(--toastify-toast-top)
}

.Toastify__toast-container--top-center {
    left: 50%;
    top: max(16px, env(safe-area-inset-top));
    top: var(--toastify-toast-top);
    transform: translateX(-50%)
}

.Toastify__toast-container--top-right {
    right: max(16px, env(safe-area-inset-right));
    right: var(--toastify-toast-right);
    top: max(16px, env(safe-area-inset-top));
    top: var(--toastify-toast-top)
}

.Toastify__toast-container--bottom-left {
    bottom: max(16px, env(safe-area-inset-bottom));
    bottom: var(--toastify-toast-bottom);
    left: max(16px, env(safe-area-inset-left));
    left: var(--toastify-toast-left)
}

.Toastify__toast-container--bottom-center {
    bottom: max(16px, env(safe-area-inset-bottom));
    bottom: var(--toastify-toast-bottom);
    left: 50%;
    transform: translateX(-50%)
}

.Toastify__toast-container--bottom-right {
    bottom: max(16px, env(safe-area-inset-bottom));
    bottom: var(--toastify-toast-bottom);
    right: max(16px, env(safe-area-inset-right));
    right: var(--toastify-toast-right)
}

@media only screen and (max-width:480px) {
    .Toastify__toast-container {
        left: env(safe-area-inset-left);
        margin: 0;
        padding: 0;
        width: 100vw
    }
    .Toastify__toast-container--top-center,
    .Toastify__toast-container--top-left,
    .Toastify__toast-container--top-right {
        top: env(safe-area-inset-top);
        transform: translateX(0)
    }
    .Toastify__toast-container--bottom-center,
    .Toastify__toast-container--bottom-left,
    .Toastify__toast-container--bottom-right {
        bottom: env(safe-area-inset-bottom);
        transform: translateX(0)
    }
    .Toastify__toast-container--rtl {
        left: auto;
        right: env(safe-area-inset-right)
    }
}

.Toastify__toast {
    --y: 0;
    border-radius: 6px;
    border-radius: var(--toastify-toast-bd-radius);
    box-shadow: 0 4px 12px #0000001a;
    box-sizing: border-box;
    cursor: default;
    direction: ltr;
    display: flex;
    font-family: sans-serif;
    font-family: var(--toastify-font-family);
    justify-content: space-between;
    margin-bottom: 1rem;
    max-height: 800px;
    max-height: var(--toastify-toast-max-height);
    min-height: 64px;
    min-height: var(--toastify-toast-min-height);
    overflow: hidden;
    padding: 8px;
    position: relative;
    touch-action: none;
    z-index: 0
}

.Toastify__toast--stacked {
    position: absolute;
    transform: translate3d(0, var(--y), 0) scale(var(--s));
    transition: transform .3s;
    width: 100%
}

.Toastify__toast--stacked[data-collapsed] .Toastify__close-button,
.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body {
    transition: opacity .1s
}

.Toastify__toast--stacked[data-collapsed=false] {
    overflow: visible
}

.Toastify__toast--stacked[data-collapsed=true]:not(:last-child)>* {
    opacity: 0
}

.Toastify__toast--stacked:after {
    bottom: 100%;
    content: "";
    height: calc(var(--g)*1px);
    left: 0;
    position: absolute;
    right: 0
}

.Toastify__toast--stacked[data-pos=top] {
    top: 0
}

.Toastify__toast--stacked[data-pos=bot] {
    bottom: 0
}

.Toastify__toast--stacked[data-pos=bot].Toastify__toast--stacked:before {
    transform-origin: top
}

.Toastify__toast--stacked[data-pos=top].Toastify__toast--stacked:before {
    transform-origin: bottom
}

.Toastify__toast--stacked:before {
    bottom: 0;
    content: "";
    height: 100%;
    left: 0;
    position: absolute;
    right: 0;
    transform: scaleY(3);
    z-index: -1
}

.Toastify__toast--rtl {
    direction: rtl
}

.Toastify__toast--close-on-click {
    cursor: pointer
}

.Toastify__toast-body {
    align-items: center;
    display: flex;
    flex: 1 1 auto;
    margin: auto 0;
    padding: 6px
}

.Toastify__toast-body>div:last-child {
    flex: 1 1;
    word-break: break-word
}

.Toastify__toast-icon {
    display: flex;
    flex-shrink: 0;
    margin-inline-end: 10px;
    width: 20px
}

.Toastify--animate {
    animation-duration: .5s;
    animation-fill-mode: both
}

.Toastify--animate-icon {
    animation-duration: .3s;
    animation-fill-mode: both
}

@media only screen and (max-width:480px) {
    .Toastify__toast {
        border-radius: 0;
        margin-bottom: 0
    }
}

.Toastify__toast-theme--dark {
    background: #121212;
    background: var(--toastify-color-dark);
    color: #fff;
    color: var(--toastify-text-color-dark)
}

.Toastify__toast-theme--colored.Toastify__toast--default,
.Toastify__toast-theme--light {
    background: #fff;
    background: var(--toastify-color-light);
    color: #757575;
    color: var(--toastify-text-color-light)
}

.Toastify__toast-theme--colored.Toastify__toast--info {
    background: #3498db;
    background: var(--toastify-color-info);
    color: #fff;
    color: var(--toastify-text-color-info)
}

.Toastify__toast-theme--colored.Toastify__toast--success {
    background: #07bc0c;
    background: var(--toastify-color-success);
    color: #fff;
    color: var(--toastify-text-color-success)
}

.Toastify__toast-theme--colored.Toastify__toast--warning {
    background: #f1c40f;
    background: var(--toastify-color-warning);
    color: #fff;
    color: var(--toastify-text-color-warning)
}

.Toastify__toast-theme--colored.Toastify__toast--error {
    background: #e74c3c;
    background: var(--toastify-color-error);
    color: #fff;
    color: var(--toastify-text-color-error)
}

.Toastify__progress-bar-theme--light {
    background: linear-gradient(90deg, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);
    background: var(--toastify-color-progress-light)
}

.Toastify__progress-bar-theme--dark {
    background: #bb86fc;
    background: var(--toastify-color-progress-dark)
}

.Toastify__progress-bar--info {
    background: #3498db;
    background: var(--toastify-color-progress-info)
}

.Toastify__progress-bar--success {
    background: #07bc0c;
    background: var(--toastify-color-progress-success)
}

.Toastify__progress-bar--warning {
    background: #f1c40f;
    background: var(--toastify-color-progress-warning)
}

.Toastify__progress-bar--error {
    background: #e74c3c;
    background: var(--toastify-color-progress-error)
}

.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning {
    background: #ffffffb3;
    background: var(--toastify-color-transparent)
}

.Toastify__close-button {
    align-self: flex-start;
    background: #0000;
    border: none;
    color: #fff;
    cursor: pointer;
    opacity: .7;
    outline: none;
    padding: 0;
    transition: .3s ease;
    z-index: 1
}

.Toastify__close-button--light {
    color: #000;
    opacity: .3
}

.Toastify__close-button>svg {
    fill: currentColor;
    height: 16px;
    width: 14px
}

.Toastify__close-button:focus,
.Toastify__close-button:hover {
    opacity: 1
}

@keyframes Toastify__trackProgress {
    0% {
        transform: scaleX(1)
    }
    to {
        transform: scaleX(0)
    }
}

.Toastify__progress-bar {
    border-bottom-left-radius: 6px;
    border-bottom-left-radius: var(--toastify-toast-bd-radius);
    bottom: 0;
    height: 100%;
    left: 0;
    opacity: .7;
    position: absolute;
    transform-origin: left;
    width: 100%;
    z-index: 9999;
    z-index: var(--toastify-z-index)
}

.Toastify__progress-bar--animated {
    animation: Toastify__trackProgress linear 1 forwards
}

.Toastify__progress-bar--controlled {
    transition: transform .2s
}

.Toastify__progress-bar--rtl {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 6px;
    border-bottom-right-radius: var(--toastify-toast-bd-radius);
    left: auto;
    right: 0;
    transform-origin: right
}

.Toastify__progress-bar--wrp {
    border-bottom-left-radius: 6px;
    border-bottom-left-radius: var(--toastify-toast-bd-radius);
    bottom: 0;
    height: 5px;
    left: 0;
    position: absolute;
    width: 100%
}

.Toastify__progress-bar--wrp[data-hidden=true] {
    opacity: 0
}

.Toastify__progress-bar--bg {
    height: 100%;
    opacity: .2;
    opacity: var(--toastify-color-progress-bgo);
    width: 100%
}

.Toastify__spinner {
    animation: Toastify__spin .65s linear infinite;
    border: 2px solid #e0e0e0;
    border-color: var(--toastify-spinner-color-empty-area);
    border-radius: 100%;
    border-right-color: #616161;
    border-right-color: var(--toastify-spinner-color);
    box-sizing: border-box;
    height: 20px;
    width: 20px
}

@keyframes Toastify__bounceInRight {
    0%,
    60%,
    75%,
    90%,
    to {
        animation-timing-function: cubic-bezier(.215, .61, .355, 1)
    }
    0% {
        opacity: 0;
        transform: translate3d(3000px, 0, 0)
    }
    60% {
        opacity: 1;
        transform: translate3d(-25px, 0, 0)
    }
    75% {
        transform: translate3d(10px, 0, 0)
    }
    90% {
        transform: translate3d(-5px, 0, 0)
    }
    to {
        transform: none
    }
}

@keyframes Toastify__bounceOutRight {
    20% {
        opacity: 1;
        transform: translate3d(-20px, var(--y), 0)
    }
    to {
        opacity: 0;
        transform: translate3d(2000px, var(--y), 0)
    }
}

@keyframes Toastify__bounceInLeft {
    0%,
    60%,
    75%,
    90%,
    to {
        animation-timing-function: cubic-bezier(.215, .61, .355, 1)
    }
    0% {
        opacity: 0;
        transform: translate3d(-3000px, 0, 0)
    }
    60% {
        opacity: 1;
        transform: translate3d(25px, 0, 0)
    }
    75% {
        transform: translate3d(-10px, 0, 0)
    }
    90% {
        transform: translate3d(5px, 0, 0)
    }
    to {
        transform: none
    }
}

@keyframes Toastify__bounceOutLeft {
    20% {
        opacity: 1;
        transform: translate3d(20px, var(--y), 0)
    }
    to {
        opacity: 0;
        transform: translate3d(-2000px, var(--y), 0)
    }
}

@keyframes Toastify__bounceInUp {
    0%,
    60%,
    75%,
    90%,
    to {
        animation-timing-function: cubic-bezier(.215, .61, .355, 1)
    }
    0% {
        opacity: 0;
        transform: translate3d(0, 3000px, 0)
    }
    60% {
        opacity: 1;
        transform: translate3d(0, -20px, 0)
    }
    75% {
        transform: translate3d(0, 10px, 0)
    }
    90% {
        transform: translate3d(0, -5px, 0)
    }
    to {
        transform: translateZ(0)
    }
}

@keyframes Toastify__bounceOutUp {
    20% {
        transform: translate3d(0, calc(var(--y) - 10px), 0)
    }
    40%,
    45% {
        opacity: 1;
        transform: translate3d(0, calc(var(--y) + 20px), 0)
    }
    to {
        opacity: 0;
        transform: translate3d(0, -2000px, 0)
    }
}

@keyframes Toastify__bounceInDown {
    0%,
    60%,
    75%,
    90%,
    to {
        animation-timing-function: cubic-bezier(.215, .61, .355, 1)
    }
    0% {
        opacity: 0;
        transform: translate3d(0, -3000px, 0)
    }
    60% {
        opacity: 1;
        transform: translate3d(0, 25px, 0)
    }
    75% {
        transform: translate3d(0, -10px, 0)
    }
    90% {
        transform: translate3d(0, 5px, 0)
    }
    to {
        transform: none
    }
}

@keyframes Toastify__bounceOutDown {
    20% {
        transform: translate3d(0, calc(var(--y) - 10px), 0)
    }
    40%,
    45% {
        opacity: 1;
        transform: translate3d(0, calc(var(--y) + 20px), 0)
    }
    to {
        opacity: 0;
        transform: translate3d(0, 2000px, 0)
    }
}

.Toastify__bounce-enter--bottom-left,
.Toastify__bounce-enter--top-left {
    animation-name: Toastify__bounceInLeft
}

.Toastify__bounce-enter--bottom-right,
.Toastify__bounce-enter--top-right {
    animation-name: Toastify__bounceInRight
}

.Toastify__bounce-enter--top-center {
    animation-name: Toastify__bounceInDown
}

.Toastify__bounce-enter--bottom-center {
    animation-name: Toastify__bounceInUp
}

.Toastify__bounce-exit--bottom-left,
.Toastify__bounce-exit--top-left {
    animation-name: Toastify__bounceOutLeft
}

.Toastify__bounce-exit--bottom-right,
.Toastify__bounce-exit--top-right {
    animation-name: Toastify__bounceOutRight
}

.Toastify__bounce-exit--top-center {
    animation-name: Toastify__bounceOutUp
}

.Toastify__bounce-exit--bottom-center {
    animation-name: Toastify__bounceOutDown
}

@keyframes Toastify__zoomIn {
    0% {
        opacity: 0;
        transform: scale3d(.3, .3, .3)
    }
    50% {
        opacity: 1
    }
}

@keyframes Toastify__zoomOut {
    0% {
        opacity: 1
    }
    50% {
        opacity: 0;
        transform: translate3d(0, var(--y), 0) scale3d(.3, .3, .3)
    }
    to {
        opacity: 0
    }
}

.Toastify__zoom-enter {
    animation-name: Toastify__zoomIn
}

.Toastify__zoom-exit {
    animation-name: Toastify__zoomOut
}

@keyframes Toastify__flipIn {
    0% {
        animation-timing-function: ease-in;
        opacity: 0;
        transform: perspective(400px) rotateX(90deg)
    }
    40% {
        animation-timing-function: ease-in;
        transform: perspective(400px) rotateX(-20deg)
    }
    60% {
        opacity: 1;
        transform: perspective(400px) rotateX(10deg)
    }
    80% {
        transform: perspective(400px) rotateX(-5deg)
    }
    to {
        transform: perspective(400px)
    }
}

@keyframes Toastify__flipOut {
    0% {
        transform: translate3d(0, var(--y), 0) perspective(400px)
    }
    30% {
        opacity: 1;
        transform: translate3d(0, var(--y), 0) perspective(400px) rotateX(-20deg)
    }
    to {
        opacity: 0;
        transform: translate3d(0, var(--y), 0) perspective(400px) rotateX(90deg)
    }
}

.Toastify__flip-enter {
    animation-name: Toastify__flipIn
}

.Toastify__flip-exit {
    animation-name: Toastify__flipOut
}

@keyframes Toastify__slideInRight {
    0% {
        transform: translate3d(110%, 0, 0);
        visibility: visible
    }
    to {
        transform: translate3d(0, var(--y), 0)
    }
}

@keyframes Toastify__slideInLeft {
    0% {
        transform: translate3d(-110%, 0, 0);
        visibility: visible
    }
    to {
        transform: translate3d(0, var(--y), 0)
    }
}

@keyframes Toastify__slideInUp {
    0% {
        transform: translate3d(0, 110%, 0);
        visibility: visible
    }
    to {
        transform: translate3d(0, var(--y), 0)
    }
}

@keyframes Toastify__slideInDown {
    0% {
        transform: translate3d(0, -110%, 0);
        visibility: visible
    }
    to {
        transform: translate3d(0, var(--y), 0)
    }
}

@keyframes Toastify__slideOutRight {
    0% {
        transform: translate3d(0, var(--y), 0)
    }
    to {
        transform: translate3d(110%, var(--y), 0);
        visibility: hidden
    }
}

@keyframes Toastify__slideOutLeft {
    0% {
        transform: translate3d(0, var(--y), 0)
    }
    to {
        transform: translate3d(-110%, var(--y), 0);
        visibility: hidden
    }
}

@keyframes Toastify__slideOutDown {
    0% {
        transform: translate3d(0, var(--y), 0)
    }
    to {
        transform: translate3d(0, 500px, 0);
        visibility: hidden
    }
}

@keyframes Toastify__slideOutUp {
    0% {
        transform: translate3d(0, var(--y), 0)
    }
    to {
        transform: translate3d(0, -500px, 0);
        visibility: hidden
    }
}

.Toastify__slide-enter--bottom-left,
.Toastify__slide-enter--top-left {
    animation-name: Toastify__slideInLeft
}

.Toastify__slide-enter--bottom-right,
.Toastify__slide-enter--top-right {
    animation-name: Toastify__slideInRight
}

.Toastify__slide-enter--top-center {
    animation-name: Toastify__slideInDown
}

.Toastify__slide-enter--bottom-center {
    animation-name: Toastify__slideInUp
}

.Toastify__slide-exit--bottom-left,
.Toastify__slide-exit--top-left {
    animation-duration: .3s;
    animation-name: Toastify__slideOutLeft;
    animation-timing-function: ease-in
}

.Toastify__slide-exit--bottom-right,
.Toastify__slide-exit--top-right {
    animation-duration: .3s;
    animation-name: Toastify__slideOutRight;
    animation-timing-function: ease-in
}

.Toastify__slide-exit--top-center {
    animation-duration: .3s;
    animation-name: Toastify__slideOutUp;
    animation-timing-function: ease-in
}

.Toastify__slide-exit--bottom-center {
    animation-duration: .3s;
    animation-name: Toastify__slideOutDown;
    animation-timing-function: ease-in
}

@keyframes Toastify__spin {
    0% {
        transform: rotate(0deg)
    }
    to {
        transform: rotate(1turn)
    }
}

/*# sourceMappingURL=main.3edfef36.css.map*/

/* V0 check-in redesign tokens and components */
:root {
    --v0-navy: #1b3a6b;
    --v0-navy-light: #2a4f8e;
    --v0-success: #22c55e;
    --v0-success-light: #dcfce7;
    --v0-upload-bg: #eff6ff;
    --v0-upload-border: #93c5fd;
    --v0-background: #f8fafc;
    --v0-card: #ffffff;
    --v0-secondary: #f1f5f9;
    --v0-muted: #64748b;
    --v0-border: #e2e8f0;
}

body {
    background: var(--v0-background);
}

.v0-shell {
    display: flex;
    flex-direction: column;
    min-height: 100dvh;
    max-width: 430px;
    margin: 0 auto;
    background: var(--v0-background);
}

.v0-top-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 56px;
    padding: 12px 20px;
    background: #fff;
    border-bottom: 1px solid var(--v0-border);
}

.v0-brand,
.v0-secure-badge {
    display: flex;
    align-items: center;
}

.v0-top-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.v0-brand {
    gap: 8px;
    color: var(--v0-navy);
    font-size: 14px;
    font-weight: 700;
    letter-spacing: -0.01em;
}

.v0-brand-mark {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background: var(--v0-navy);
    color: #fff;
    font-size: 12px;
    font-weight: 800;
}

.v0-secure-badge {
    gap: 6px;
    padding: 6px 12px;
    border: 1px solid var(--v0-upload-border);
    border-radius: 999px;
    background: var(--v0-upload-bg);
    color: var(--v0-navy);
    font-size: 12px;
    font-weight: 700;
}

.v0-language-switch {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.v0-language-options {
    display: inline-flex;
    gap: 2px;
    padding: 2px;
    border: 1px solid var(--v0-border);
    border-radius: 9px;
    background: var(--v0-secondary);
}

.v0-language-button {
    min-width: 34px;
    min-height: 30px;
    padding: 4px 8px;
    border: 0;
    border-radius: 7px;
    background: transparent;
    color: var(--v0-muted);
    font: inherit;
    font-size: 11px;
    font-weight: 800;
    line-height: 1;
    cursor: pointer;
}

.v0-language-button[aria-pressed="true"] {
    background: var(--v0-navy);
    color: #fff;
    box-shadow: 0 1px 3px rgba(27, 58, 107, 0.22);
}

.v0-language-button:focus-visible {
    outline: 2px solid var(--v0-navy-light);
    outline-offset: 2px;
}

.v0-language-message {
    display: none;
    width: 190px;
    margin-top: 5px;
    color: #92400e;
    font-size: 11px;
    font-weight: 700;
    line-height: 1.35;
    text-align: right;
}

.v0-language-message.is-visible {
    display: block;
}

.v0-language-switch--top .v0-language-message {
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 20;
    padding: 8px 10px;
    border: 1px solid #fcd34d;
    border-radius: 9px;
    background: #fef3c7;
    box-shadow: 0 4px 14px rgba(146, 64, 14, 0.14);
}

.v0-main-card {
    display: flex;
    flex: 1;
    flex-direction: column;
    overflow: hidden;
    margin: 12px;
    border-radius: 20px;
    background: var(--v0-card);
    box-shadow: 0 4px 24px rgba(27, 58, 107, 0.1), 0 1px 4px rgba(27, 58, 107, 0.06);
}

.v0-card-scroll {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
}

.v0-card-stack {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.v0-section-label {
    margin: 0 0 8px;
    color: var(--v0-muted);
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.08em;
    line-height: 1.2;
    text-transform: uppercase;
}

.v0-hero-copy {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.v0-hero-copy h1 {
    margin: 0;
    color: var(--v0-navy);
    font-size: 24px;
    font-weight: 800;
    letter-spacing: -0.03em;
}

.v0-hero-copy p {
    margin: 0;
    color: var(--v0-muted);
    font-size: 13px;
    line-height: 1.5;
}

.v0-upload-wrapper {
    position: relative;
}

.v0-upload-zone {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 180px;
    overflow: hidden;
    border: 2px dashed var(--v0-upload-border);
    border-radius: 18px;
    background: var(--v0-upload-bg);
    color: var(--v0-navy);
    cursor: pointer;
    transition: border-color 0.2s ease, background 0.2s ease, transform 0.2s ease;
}

.v0-upload-zone:hover {
    transform: translateY(-1px);
    border-color: var(--v0-navy-light);
}

.v0-upload-zone.is-uploading,
.v0-upload-zone.is-verified {
    cursor: default;
}

.v0-upload-zone.is-verified {
    border-color: var(--v0-success);
    background: var(--v0-success-light);
}

.v0-upload-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 24px;
    text-align: center;
    animation: v0-fade-in 0.25s ease-out;
}

.v0-upload-icon {
    display: inline-flex;
    color: var(--v0-navy);
}

.v0-upload-title {
    margin: 0;
    color: var(--v0-navy);
    font-size: 18px;
    font-weight: 800;
    line-height: 1.2;
}

.v0-upload-copy,
.v0-upload-file {
    margin: 0;
    color: var(--v0-muted);
    font-size: 13px;
    line-height: 1.4;
}

.v0-upload-file {
    max-width: 240px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.v0-preview-wrap {
    position: relative;
    width: 80px;
    height: 80px;
}

.v0-preview {
    width: 80px;
    height: 80px;
    object-fit: cover;
    border: 1px solid var(--v0-border);
    border-radius: 12px;
    box-shadow: 0 6px 18px rgba(15, 23, 42, 0.12);
}

.v0-selfie-camera.is-selfie-live {
    min-height: 220px;
    cursor: default;
}

.v0-selfie-camera.is-selfie-live:hover {
    transform: none;
}

.v0-selfie-live-inner {
    padding: 12px;
}

.v0-selfie-video {
    width: 100%;
    max-width: 360px;
    max-height: 240px;
    border-radius: 14px;
    background: #0f172a;
    object-fit: contain;
}

.v0-selfie-preview-wrap {
    width: auto;
    height: auto;
    max-width: 120px;
}

.v0-selfie-preview {
    width: 96px;
    height: 96px;
}

.v0-selfie-actions {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    width: 100%;
    max-width: 360px;
}

.v0-selfie-actions-row {
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.v0-selfie-capture-btn {
    flex: 1;
    min-height: 48px;
    animation: none;
}

.v0-selfie-capture-btn:not(:disabled) {
    animation: none;
}

.v0-selfie-camera.is-selfie-idle-clickable {
    cursor: pointer;
}

.v0-selfie-camera.is-selfie-idle-clickable:hover {
    transform: translateY(-1px);
    border-color: var(--v0-navy-light);
}

.v0-selfie-camera.is-selfie-idle-disabled {
    cursor: not-allowed;
    opacity: 0.75;
}

.v0-primary-button.v0-selfie-open-pill {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    box-sizing: border-box;
    min-height: 52px;
    padding: 0 1.25rem;
    pointer-events: none;
    user-select: none;
}

.v0-check-bubble,
.v0-success-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--v0-success);
}

.v0-check-bubble {
    position: absolute;
    top: -8px;
    right: -8px;
    width: 26px;
    height: 26px;
    border-radius: 999px;
    background: #fff;
    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.14);
}

.v0-spinner {
    width: 38px;
    height: 38px;
    border: 3px solid rgba(27, 58, 107, 0.18);
    border-top-color: var(--v0-navy);
    border-radius: 999px;
    animation: v0-spin 0.8s linear infinite;
}

.v0-consent {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.v0-consent-heading-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 8px;
}

.v0-consent-heading-row .v0-section-label {
    margin-bottom: 0;
}

@media (max-width: 380px) {
    .v0-top-bar {
        padding-inline: 12px;
    }

    .v0-secure-badge span {
        display: none;
    }

    .v0-secure-badge {
        padding-inline: 8px;
    }
}

.v0-page-error-banner {
    display: flex;
    align-items: flex-start;
    gap: 14px;
    margin: 0 0 20px;
    padding: 16px 18px;
    border-radius: 14px;
    border: 1px solid #d5dee2;
    background: #f5f8f9;
}

.v0-page-error-icon {
    flex: 0 0 auto;
    color: #52636d;
    line-height: 1;
    margin-top: 2px;
}

.v0-page-error-text {
    margin: 0;
    flex: 1;
    color: #34454f;
    font-size: 15px;
    font-weight: 400;
    line-height: 1.45;
}

.v0-page-success-banner {
    display: flex;
    align-items: flex-start;
    gap: 14px;
    margin: 0 0 20px;
    padding: 16px 18px;
    border-radius: 14px;
    border: 1px solid rgba(22, 101, 52, 0.32);
    background: linear-gradient(135deg, #ecfdf3 0%, #f0fdf4 100%);
    box-shadow: 0 4px 18px rgba(22, 101, 52, 0.12);
}

.v0-page-success-icon {
    flex: 0 0 auto;
    color: #15803d;
    line-height: 1;
    margin-top: 2px;
}

.v0-page-success-copy {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 0;
}

.v0-page-success-text {
    margin: 0;
    color: #14532d;
    font-size: 15px;
    font-weight: 600;
    line-height: 1.45;
}

.v0-page-success-detail {
    margin: 0;
    color: #166534;
    font-size: 15px;
    font-weight: 500;
    line-height: 1.45;
}

.v0-page-success-text--secondary {
    font-weight: 500;
    color: #166534;
}

.v0-agreement-box {
    border: none;
    background: transparent;
    overflow: visible;
}

.v0-agreement-panel-loading,
.v0-agreement-panel {
    border-radius: 12px;
    padding: 12px;
    font-size: 13px;
    line-height: 1.625;
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 72px;
    background: var(--v0-secondary);
    color: var(--v0-muted);
    border: 1px solid var(--v0-border);
    -webkit-overflow-scrolling: touch;
}

.v0-agreement-summary-title {
    margin: 0 0 2px;
    padding: 0;
    font-weight: 600;
    font-size: 13px;
    color: var(--v0-navy);
}

.v0-agreement-body {
    margin: 0 0 6px;
    color: var(--v0-muted);
    font-size: 13px;
    line-height: 1.625;
}

.v0-agreement-body:last-child {
    margin-bottom: 0;
}

.v0-agreement-panel-loading {
    margin: 0;
    max-height: none;
}

.v0-agreement-status {
    margin: 0;
    padding: 14px 16px;
    font-size: 14px;
    color: var(--v0-muted);
}

.v0-agreement-status--error {
    color: #b91c1c;
    font-weight: 600;
}

.v0-legal-notice {
    border: 1px solid var(--v0-border);
    border-radius: 12px;
    background: var(--v0-secondary);
    color: var(--v0-muted);
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 12px;
}

.v0-legal-notice svg {
    flex: 0 0 auto;
    margin-top: 2px;
}

.v0-legal-notice p {
    margin: 0;
    font-size: 11px;
    line-height: 1.45;
}

.v0-consent-row {
    display: flex;
    align-items: center;
    gap: 12px;
    min-height: 44px;
    margin: 0;
    cursor: pointer;
    opacity: 1;
    transition: opacity 0.2s ease;
}

.v0-consent-row.is-disabled {
    pointer-events: none;
    opacity: 0.45;
}

.v0-checkbox {
    position: relative;
    flex: 0 0 auto;
    width: 28px;
    height: 28px;
}

.v0-checkbox input {
    position: absolute;
    inset: 0;
    width: 28px;
    height: 28px;
    opacity: 0;
    cursor: pointer;
}

.v0-checkbox-visual {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border: 2px solid var(--v0-border);
    border-radius: 8px;
    background: #fff;
    color: #fff;
    transition: background 0.2s ease, border-color 0.2s ease;
}

.v0-checkbox input:checked + .v0-checkbox-visual {
    border-color: var(--v0-navy);
    background: var(--v0-navy);
}

.v0-consent-text {
    color: var(--v0-navy);
    font-size: 14px;
    font-weight: 700;
    line-height: 1.35;
}

.v0-consent-text a {
    color: var(--v0-navy-light);
    text-decoration: underline;
}

.v0-inline-hint-wrap {
    overflow: hidden;
}

.v0-inline-hint {
    display: flex;
    align-items: center;
    gap: 8px;
    max-height: 0;
    overflow: hidden;
    padding: 0 12px;
    border: 1px solid transparent;
    border-radius: 12px;
    background: #fef3c7;
    color: #92400e;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.35;
    opacity: 0;
    transition: max-height 0.25s ease, opacity 0.25s ease, padding 0.25s ease, border-color 0.25s ease;
}

.v0-inline-hint.is-visible {
    max-height: 120px;
    padding: 10px 12px;
    border-color: #fcd34d;
    opacity: 1;
}

.v0-sticky-footer {
    padding: 12px 16px 20px;
    border-top: 1px solid var(--v0-border);
    background: #fff;
}

.v0-primary-button {
    width: 100%;
    min-height: 52px;
    border: 0;
    border-radius: 18px;
    background: var(--v0-navy);
    color: #fff;
    font-size: 16px;
    font-weight: 800;
    cursor: pointer;
    transition: opacity 0.2s ease, transform 0.2s ease;
}

.v0-primary-button:not(:disabled) {
    animation: v0-pulse-btn 1.5s ease-in-out infinite;
}

.v0-primary-button:hover:not(:disabled) {
    transform: translateY(-1px);
}

.v0-primary-button:disabled {
    background: var(--v0-muted);
    cursor: not-allowed;
    opacity: 0.55;
}

.v0-review-form {
    display: flex;
    flex-direction: column;
    gap: 18px;
}

.v0-member-card {
    padding: 16px;
    border: 1px solid var(--v0-border);
    border-radius: 18px;
    background: #fff;
    box-shadow: 0 1px 8px rgba(15, 23, 42, 0.04);
}

.v0-member-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
}

.v0-member-title {
    margin: 0;
    color: var(--v0-navy);
    font-size: 18px;
    font-weight: 800;
}

.v0-ghost-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    min-height: 36px;
    padding: 7px 12px;
    border: 1px solid var(--v0-border);
    border-radius: 999px;
    background: var(--v0-secondary);
    color: var(--v0-navy);
    font-size: 13px;
    font-weight: 800;
    cursor: pointer;
}

.v0-ghost-button.danger {
    color: #b91c1c;
}

.v0-two-col {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
}

.v0-field-row {
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px;
}

.v0-add-guest {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 16px;
    border: 1px dashed var(--v0-upload-border);
    border-radius: 18px;
    background: var(--v0-upload-bg);
    color: var(--v0-muted);
    text-align: center;
    font-size: 13px;
}

.v0-add-guest .v0-ghost-button {
    background: #fff;
}

.v0-not-found-panel {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding: 24px 12px 32px;
    text-align: center;
}

.v0-not-found-badge {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    border-radius: 999px;
    background: #fffbeb;
    border: 1px solid #fde68a;
    color: #b45309;
}

.v0-not-found-code {
    margin: 0;
    color: var(--v0-navy);
    font-size: 52px;
    font-weight: 800;
    letter-spacing: -0.06em;
    line-height: 1;
}

.v0-not-found-copy {
    align-items: center;
    max-width: 320px;
}

.v0-not-found-copy h1 {
    font-size: 22px;
    line-height: 1.25;
}

.v0-not-found-copy p {
    font-size: 14px;
    line-height: 1.55;
}

.v0-not-found-retry {
    max-width: 240px;
}

.v0-expired-panel .v0-not-found-badge {
    background: #eff6ff;
    border-color: var(--v0-upload-border);
    color: var(--v0-navy);
}

.v0-inline-error {
    padding: 12px 14px;
    border-radius: 14px;
    border: 1px solid #fecaca;
    background: #fef2f2;
    color: #991b1b;
    font-size: 14px;
    line-height: 1.45;
}

.v0-success-panel {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;
    padding: 32px 20px;
    color: #166534;
    text-align: center;
}

.v0-success-panel h4 {
    margin: 0;
    color: #15803d;
    font-size: 22px;
    font-weight: 800;
}

.v0-success-panel p {
    margin: 0;
    color: #166534;
    font-size: 15px;
    line-height: 1.5;
}

.v0-success-badge {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 70px;
    height: 70px;
    border-radius: 999px;
    background: var(--v0-success-light);
    color: var(--v0-success);
}

.v0-modal-content {
    max-width: 380px;
    width: calc(100% - 32px);
    margin: 25vh auto auto;
    border: 0;
    border-radius: 20px;
    box-shadow: 0 20px 50px rgba(15, 23, 42, 0.25);
}

.v0-modal-actions {
    justify-content: center;
    gap: 12px;
}

@keyframes v0-spin {
    to {
        transform: rotate(360deg);
    }
}

@keyframes v0-pulse-btn {
    0%, 100% {
        box-shadow: 0 0 0 0 rgba(27, 58, 107, 0.4);
    }
    50% {
        box-shadow: 0 0 0 8px rgba(27, 58, 107, 0);
    }
}

@keyframes v0-fade-in {
    from {
        opacity: 0;
        transform: translateY(6px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (max-width: 600px) {
    .v0-main-card {
        margin: 12px;
    }

    .v0-two-col {
        grid-template-columns: 1fr;
        gap: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./index.css"],"names":[],"mappings":"AACA;;;;IAII,8BAA8B;IAC9B,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,sBAAsB;IACtB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;IACtB;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,YAAY;IACZ,8BAA8B;IAC9B;AACJ;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,cAAc;IACd,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,oBAAoB;IACpB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,aAAa;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB,4CAA4C;IAC5C,6CAA6C;IAC7C,6BAA6B;IAC7B,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB;AACJ;;AAEA;IACI,uBAAuB;IACvB,gCAAgC;IAChC,0CAA0C;IAC1C,2CAA2C;IAC3C,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf;AACJ;;AAEA;;IAEI,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI,qBAAqB;QACrB,eAAe;QACf,aAAa;QACb,uBAAuB;QACvB;IACJ;IACA;QACI,2BAA2B;QAC3B;IACJ;IACA;;QAEI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI,eAAe;QACf,YAAY;QACZ;IACJ;IACA;QACI;IACJ;IACA;QACI,aAAa;QACb;IACJ;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,mBAAmB;QACnB;IACJ;IACA;QACI,eAAe;QACf,kBAAkB;QAClB,eAAe;QACf;IACJ;IACA;QACI,8BAA8B;QAC9B;IACJ;IACA;;QAEI,aAAa;QACb,mBAAmB;QACnB,cAAc;QACd;IACJ;IACA;QACI,aAAa;QACb,sBAAsB;QACtB;IACJ;IACA;QACI,eAAe;QACf;IACJ;IACA;QACI,eAAe;QACf;IACJ;IACA;QACI,aAAa;QACb,uBAAuB;QACvB;IACJ;IACA;QACI,0BAA0B;QAC1B,eAAe;QACf;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;IACA;QACI;IACJ;AACJ;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,4BAA4B;IAC5B,8BAA8B;IAC9B,8BAA8B;IAC9B,iCAAiC;IACjC,iCAAiC;IACjC,+BAA+B;IAC/B,uCAAuC;IACvC,sDAAsD;IACtD,4DAA4D;IAC5D,4DAA4D;IAC5D,wDAAwD;IACxD,6BAA6B;IAC7B,6BAA6B;IAC7B,iFAAiF;IACjF,qFAAqF;IACrF,mFAAmF;IACnF,uFAAuF;IACvF,iCAAiC;IACjC,iCAAiC;IACjC,kCAAkC;IAClC,+BAA+B;IAC/B,kCAAkC;IAClC,wBAAwB;IACxB,oCAAoC;IACpC,gCAAgC;IAChC,gCAAgC;IAChC,mCAAmC;IACnC,mCAAmC;IACnC,iCAAiC;IACjC,iCAAiC;IACjC,4CAA4C;IAC5C,6GAA6G;IAC7G,uCAAuC;IACvC,0DAA0D;IAC1D,gEAAgE;IAChE,gEAAgE;IAChE,4DAA4D;IAC5D;AACJ;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mCAAmC;IACnC,sDAAsD;IACtD,YAAY;IACZ,kCAAkC;IAClC,aAAa;IACb;AACJ;;AAEA;IACI,0CAA0C;IAC1C,gCAAgC;IAChC,wCAAwC;IACxC;AACJ;;AAEA;IACI,SAAS;IACT,wCAAwC;IACxC,8BAA8B;IAC9B;AACJ;;AAEA;IACI,4CAA4C;IAC5C,kCAAkC;IAClC,wCAAwC;IACxC;AACJ;;AAEA;IACI,8CAA8C;IAC9C,oCAAoC;IACpC,0CAA0C;IAC1C;AACJ;;AAEA;IACI,8CAA8C;IAC9C,oCAAoC;IACpC,SAAS;IACT;AACJ;;AAEA;IACI,8CAA8C;IAC9C,oCAAoC;IACpC,4CAA4C;IAC5C;AACJ;;AAEA;IACI;QACI,+BAA+B;QAC/B,SAAS;QACT,UAAU;QACV;IACJ;IACA;;;QAGI,6BAA6B;QAC7B;IACJ;IACA;;;QAGI,mCAAmC;QACnC;IACJ;IACA;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;IACI,MAAM;IACN,kBAAkB;IAClB,8CAA8C;IAC9C,gCAAgC;IAChC,sBAAsB;IACtB,eAAe;IACf,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,wCAAwC;IACxC,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,4CAA4C;IAC5C,gBAAgB;IAChB,4CAA4C;IAC5C,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,sDAAsD;IACtD,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0BAA0B;IAC1B,OAAO;IACP,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,cAAc;IACd;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd,uBAAuB;IACvB;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,sCAAsC;IACtC,WAAW;IACX;AACJ;;AAEA;;IAEI,gBAAgB;IAChB,uCAAuC;IACvC,cAAc;IACd;AACJ;;AAEA;IACI,mBAAmB;IACnB,sCAAsC;IACtC,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB,yCAAyC;IACzC,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB,yCAAyC;IACzC,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB,uCAAuC;IACvC,WAAW;IACX;AACJ;;AAEA;IACI,wFAAwF;IACxF;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;;;;IAII,qBAAqB;IACrB;AACJ;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,WAAW;IACX,aAAa;IACb,UAAU;IACV,oBAAoB;IACpB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;QACI;IACJ;IACA;QACI;IACJ;AACJ;;AAEA;IACI,8BAA8B;IAC9B,0DAA0D;IAC1D,SAAS;IACT,YAAY;IACZ,OAAO;IACP,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;IAC/B,2DAA2D;IAC3D,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,8BAA8B;IAC9B,0DAA0D;IAC1D,SAAS;IACT,WAAW;IACX,OAAO;IACP,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,2CAA2C;IAC3C;AACJ;;AAEA;IACI,8CAA8C;IAC9C,yBAAyB;IACzB,sDAAsD;IACtD,mBAAmB;IACnB,2BAA2B;IAC3B,iDAAiD;IACjD,sBAAsB;IACtB,YAAY;IACZ;AACJ;;AAEA;IACI;;;;;QAKI;IACJ;IACA;QACI,UAAU;QACV;IACJ;IACA;QACI,UAAU;QACV;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,UAAU;QACV;IACJ;IACA;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;IACI;;;;;QAKI;IACJ;IACA;QACI,UAAU;QACV;IACJ;IACA;QACI,UAAU;QACV;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,UAAU;QACV;IACJ;IACA;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;IACI;;;;;QAKI;IACJ;IACA;QACI,UAAU;QACV;IACJ;IACA;QACI,UAAU;QACV;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;IACA;;QAEI,UAAU;QACV;IACJ;IACA;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;IACI;;;;;QAKI;IACJ;IACA;QACI,UAAU;QACV;IACJ;IACA;QACI,UAAU;QACV;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;IACA;;QAEI,UAAU;QACV;IACJ;IACA;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,UAAU;QACV;IACJ;IACA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;IACA;QACI,UAAU;QACV;IACJ;IACA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,kCAAkC;QAClC,UAAU;QACV;IACJ;IACA;QACI,kCAAkC;QAClC;IACJ;IACA;QACI,UAAU;QACV;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;IACA;QACI,UAAU;QACV;IACJ;IACA;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,kCAAkC;QAClC;IACJ;IACA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,mCAAmC;QACnC;IACJ;IACA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,kCAAkC;QAClC;IACJ;IACA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,mCAAmC;QACnC;IACJ;IACA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;IACA;QACI,yCAAyC;QACzC;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;IACA;QACI,0CAA0C;QAC1C;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;IACA;QACI,mCAAmC;QACnC;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;IACA;QACI,oCAAoC;QACpC;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,uBAAuB;IACvB,sCAAsC;IACtC;AACJ;;AAEA;;IAEI,uBAAuB;IACvB,uCAAuC;IACvC;AACJ;;AAEA;IACI,uBAAuB;IACvB,oCAAoC;IACpC;AACJ;;AAEA;IACI,uBAAuB;IACvB,sCAAsC;IACtC;AACJ;;AAEA;IACI;QACI;IACJ;IACA;QACI;IACJ;AACJ;;AAEA,2CAA2C;;AAE3C,+CAA+C;AAC/C;IACI,kBAAkB;IAClB,wBAAwB;IACxB,qBAAqB;IACrB,2BAA2B;IAC3B,uBAAuB;IACvB,2BAA2B;IAC3B,wBAAwB;IACxB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;;IAEI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,QAAQ;IACR,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,0BAA0B;IAC1B,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,QAAQ;IACR,iBAAiB;IACjB,yCAAyC;IACzC,oBAAoB;IACpB,+BAA+B;IAC/B,qBAAqB;IACrB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,QAAQ;IACR,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,WAAW;IACX,6CAA6C;AACjD;;AAEA;IACI,uCAAuC;IACvC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,OAAO;IACP,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,0BAA0B;IAC1B,gFAAgF;AACpF;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,SAAS;IACT,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,0CAA0C;IAC1C,mBAAmB;IACnB,+BAA+B;IAC/B,qBAAqB;IACrB,eAAe;IACf,6EAA6E;AACjF;;AAEA;IACI,2BAA2B;IAC3B,kCAAkC;AACtC;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI,SAAS;IACT,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kCAAkC;IAClC,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;;IAEI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;IAChB,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,gCAAgC;IAChC,oBAAoB;IACpB,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,OAAO;IACP,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,yCAAyC;IACzC,6DAA6D;IAC7D,8CAA8C;AAClD;;AAEA;IACI,cAAc;IACd,cAAc;IACd,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;;IAEI,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;IAC/B,sBAAsB;IACtB,kCAAkC;IAClC,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,+BAA+B;IAC/B,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,wDAAwD;AAC5D;;AAEA;IACI,4BAA4B;IAC5B,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,kGAAkG;AACtG;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,0BAA0B;IAC1B,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,kDAAkD;AACtD;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,mBAAmB;IACnB,gBAAgB;IAChB,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,qBAAqB;IACrB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,kCAAkC;IAClC,oBAAoB;IACpB,+BAA+B;IAC/B,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,aAAa;IACb,0CAA0C;IAC1C,mBAAmB;IACnB,+BAA+B;IAC/B,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;IACrC,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mCAAmC;IACnC,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA;IACI,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,0CAA0C;IAC9C;IACA;QACI,0CAA0C;IAC9C;AACJ;;AAEA;IACI;QACI,UAAU;QACV,0BAA0B;IAC9B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,0BAA0B;QAC1B,MAAM;IACV;AACJ","sourcesContent":["@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap);\n#root,\n.app,\nbody,\nhtml {\n    font-family: Inter, sans-serif;\n    height: 100%;\n    width: 100%\n}\n\n::-webkit-scrollbar {\n    width: 10px\n}\n\n::-webkit-scrollbar-track {\n    background: #7a7f9d\n}\n\n::-webkit-scrollbar-thumb,\n::-webkit-scrollbar-track:hover {\n    background: #21295c\n}\n\n.borderless-table {\n    border-collapse: collapse;\n    width: 100%\n}\n\n.borderless-table td,\n.borderless-table th {\n    border: 1px solid #000;\n    padding: 8px\n}\n\n.borderless-table {\n    border-left: none;\n    border-right: none\n}\n\n.mg20 {\n    margin: 20px\n}\n\n.mb25 {\n    margin-bottom: 25px\n}\n\n.container2 {\n    margin: auto;\n    position: relative;\n    width: 600px\n}\n\n.btn-upload {\n    position: absolute !important;\n    right: 10px\n}\n\n.file-name {\n    display: inline-block;\n    max-width: 300px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    vertical-align: middle;\n    white-space: nowrap\n}\n\n.list-group {\n    margin: 0;\n    padding: 0\n}\n\n.list-header {\n    margin-top: 10px !important\n}\n\n.upload-message {\n    color: #63a84e;\n    font-weight: 700;\n    margin-top: 20px !important\n}\n\n.upload-message.error {\n    color: #da4148\n}\n\n.btn-choose {\n    margin-right: 10px !important\n}\n\n.borderless-table td:first-child,\n.borderless-table th:first-child {\n    border-left: none\n}\n\n.borderless-table td:last-child,\n.borderless-table th:last-child {\n    border-right: none\n}\n\n.card {\n    margin: auto;\n    opacity: 97%;\n    width: 700px\n}\n\n.card2 {\n    width: 1000px\n}\n\n.guestName {\n    font-size: 40px\n}\n\n.reservationInfo {\n    font-size: 16.6px\n}\n\n.selectRadio {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    margin-bottom: 10px;\n    margin-top: 20px\n}\n\n.represent {\n    font-size: 23.4px;\n    margin-right: 30px;\n    white-space: nowrap\n}\n\n.isIndividual {\n    font-size: 20px;\n}\n\n.formControl {\n    display: flex;\n    flex-direction: row\n}\n\n.inputLabel {\n    font-size: 20px;\n    margin-right: 15px;\n    margin-top: 7px;\n    white-space: nowrap\n}\n\n.inputFieldItem {\n    height: 37px;\n    justify-content: space-between;\n    margin-right: 20px\n}\n\n.inputCountrySelect,\n.inputFieldItem {\n    display: flex;\n    flex-direction: row;\n    margin-left: 20px;\n    margin-top: 15px\n}\n\n.vatFieldDirection {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between\n}\n\n.declareText {\n    font-size: 26px;\n    margin-top: 10px\n}\n\n.totalMoney {\n    font-size: 32px;\n    margin-top: 10px;\n    text-align: center\n}\n\n.finalButtonField {\n    display: flex;\n    justify-content: center;\n    margin-top: 25px\n}\n\n.finalButton {\n    font-family: -apple-system;\n    font-size: 30px;\n    text-align: center\n}\n\n.errorCard {\n    align-content: center;\n    font-size: 30px;\n    height: 200px;\n    margin: 200px auto auto;\n    width: 700px\n}\n\n.rentalAgreement {\n    cursor: pointer;\n    font-size: 22px\n}\n\n.Modal {\n    position: fixed;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    z-index: 1000;\n    align-items: center;\n}\n\n.Modal-Background {\n    position: fixed;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    background-color: #000;\n    background-color: #0006;\n    z-index: 1000;\n}\n\n.Modal-Content {\n    background-color: #fefefe;\n    border: 1px solid #888;\n    border-radius: .3rem;\n    margin: 300px auto auto;\n    padding: 20px;\n    position: relative;\n    width: 40%;\n    z-index: 1050;\n}\n\n.Modal-Body {\n    flex: 1 1 auto;\n    padding: 1rem;\n    position: relative\n}\n\n.Modal-Footer {\n    align-items: center;\n    border-bottom-left-radius: calc(.3rem - 1px);\n    border-bottom-right-radius: calc(.3rem - 1px);\n    border-top: 1px solid #dee2e6;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    padding: .75rem\n}\n\n.Modal-Header {\n    align-items: flex-start;\n    border-bottom: 1px solid #dee2e6;\n    border-top-left-radius: calc(-1px + .3rem);\n    border-top-right-radius: calc(-1px + .3rem);\n    display: flex;\n    justify-content: end\n}\n\n.Close {\n    color: #aaa;\n    float: right;\n    font-size: 28px;\n    font-weight: 700\n}\n\n.Close:focus,\n.Close:hover {\n    color: #000;\n    cursor: pointer;\n    text-decoration: none\n}\n\n@media screen and (max-width:1000px) {\n    .Modal-Content {\n        width: 95%\n    }\n    .rentalAgreement {\n        font-size: 18px\n    }\n    .errorCard {\n        align-content: center;\n        font-size: 20px;\n        height: 130px;\n        margin: 200px auto auto;\n        width: 100%\n    }\n    .background {\n        background-repeat: repeat-y;\n        padding: 15px\n    }\n    .card,\n    .card2 {\n        width: 100%\n    }\n    .guestName {\n        font-size: 26px\n    }\n    .reservationInfo {\n        font-size: 14px\n    }\n    .represent {\n        font-size: 18px;\n        margin: auto;\n        white-space: nowrap\n    }\n    .isIndividual {\n        font-size: 15px\n    }\n    .formControl {\n        display: flex;\n        flex-direction: column\n    }\n    .selectRadio {\n        display: flex;\n        flex-direction: row;\n        justify-content: center;\n        margin-bottom: -7px;\n        margin-top: -7px\n    }\n    .inputLabel {\n        font-size: 14px;\n        margin-right: 10px;\n        margin-top: 7px;\n        white-space: nowrap\n    }\n    .inputFieldItem {\n        justify-content: space-between;\n        margin-right: 0\n    }\n    .inputCountrySelect,\n    .inputFieldItem {\n        display: flex;\n        flex-direction: row;\n        margin-left: 0;\n        margin-top: 10px\n    }\n    .vatFieldDirection {\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between\n    }\n    .declareText {\n        font-size: 17px;\n        margin-top: 10px\n    }\n    .totalMoney {\n        font-size: 24px;\n        margin-top: 5px\n    }\n    .finalButtonField {\n        display: flex;\n        justify-content: center;\n        margin-top: 15px\n    }\n    .finalButton {\n        font-family: -apple-system;\n        font-size: 20px;\n        text-align: center\n    }\n}\n\n.App {\n    text-align: center\n}\n\n.App-logo {\n    height: 40vmin;\n    pointer-events: none\n}\n\n@media (prefers-reduced-motion:no-preference) {\n    .App-logo {\n        animation: App-logo-spin 20s linear infinite\n    }\n}\n\n.App-header {\n    align-items: center;\n    background-color: #282c34;\n    color: #fff;\n    display: flex;\n    flex-direction: column;\n    font-size: calc(10px + 2vmin);\n    justify-content: center;\n    min-height: 100vh\n}\n\n.App-link {\n    color: #61dafb\n}\n\n@keyframes App-logo-spin {\n    0% {\n        transform: rotate(0deg)\n    }\n    to {\n        transform: rotate(1turn)\n    }\n}\n\n.dropzone {\n    background-color: #fafafa;\n    border: 3px dashed #ccc;\n    color: #bdbdbd;\n    cursor: pointer;\n    margin-bottom: 30px;\n    padding: 70px\n}\n\n.dropzone,\n.selected-file-wrapper {\n    text-align: center\n}\n\n.selected-file {\n    color: #000;\n    font-size: 20px;\n    font-weight: 700\n}\n\n:root {\n    --toastify-color-light: #fff;\n    --toastify-color-dark: #121212;\n    --toastify-color-info: #3498db;\n    --toastify-color-success: #07bc0c;\n    --toastify-color-warning: #f1c40f;\n    --toastify-color-error: #e74c3c;\n    --toastify-color-transparent: #ffffffb3;\n    --toastify-icon-color-info: var(--toastify-color-info);\n    --toastify-icon-color-success: var(--toastify-color-success);\n    --toastify-icon-color-warning: var(--toastify-color-warning);\n    --toastify-icon-color-error: var(--toastify-color-error);\n    --toastify-toast-width: 320px;\n    --toastify-toast-offset: 16px;\n    --toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));\n    --toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));\n    --toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));\n    --toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));\n    --toastify-toast-background: #fff;\n    --toastify-toast-min-height: 64px;\n    --toastify-toast-max-height: 800px;\n    --toastify-toast-bd-radius: 6px;\n    --toastify-font-family: sans-serif;\n    --toastify-z-index: 9999;\n    --toastify-text-color-light: #757575;\n    --toastify-text-color-dark: #fff;\n    --toastify-text-color-info: #fff;\n    --toastify-text-color-success: #fff;\n    --toastify-text-color-warning: #fff;\n    --toastify-text-color-error: #fff;\n    --toastify-spinner-color: #616161;\n    --toastify-spinner-color-empty-area: #e0e0e0;\n    --toastify-color-progress-light: linear-gradient(90deg, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);\n    --toastify-color-progress-dark: #bb86fc;\n    --toastify-color-progress-info: var(--toastify-color-info);\n    --toastify-color-progress-success: var(--toastify-color-success);\n    --toastify-color-progress-warning: var(--toastify-color-warning);\n    --toastify-color-progress-error: var(--toastify-color-error);\n    --toastify-color-progress-bgo: 0.2\n}\n\n.Toastify__toast-container {\n    box-sizing: border-box;\n    color: #fff;\n    padding: 4px;\n    position: fixed;\n    -webkit-transform: translateZ(9999);\n    -webkit-transform: translateZ(var(--toastify-z-index));\n    width: 320px;\n    width: var(--toastify-toast-width);\n    z-index: 9999;\n    z-index: var(--toastify-z-index)\n}\n\n.Toastify__toast-container--top-left {\n    left: max(16px, env(safe-area-inset-left));\n    left: var(--toastify-toast-left);\n    top: max(16px, env(safe-area-inset-top));\n    top: var(--toastify-toast-top)\n}\n\n.Toastify__toast-container--top-center {\n    left: 50%;\n    top: max(16px, env(safe-area-inset-top));\n    top: var(--toastify-toast-top);\n    transform: translateX(-50%)\n}\n\n.Toastify__toast-container--top-right {\n    right: max(16px, env(safe-area-inset-right));\n    right: var(--toastify-toast-right);\n    top: max(16px, env(safe-area-inset-top));\n    top: var(--toastify-toast-top)\n}\n\n.Toastify__toast-container--bottom-left {\n    bottom: max(16px, env(safe-area-inset-bottom));\n    bottom: var(--toastify-toast-bottom);\n    left: max(16px, env(safe-area-inset-left));\n    left: var(--toastify-toast-left)\n}\n\n.Toastify__toast-container--bottom-center {\n    bottom: max(16px, env(safe-area-inset-bottom));\n    bottom: var(--toastify-toast-bottom);\n    left: 50%;\n    transform: translateX(-50%)\n}\n\n.Toastify__toast-container--bottom-right {\n    bottom: max(16px, env(safe-area-inset-bottom));\n    bottom: var(--toastify-toast-bottom);\n    right: max(16px, env(safe-area-inset-right));\n    right: var(--toastify-toast-right)\n}\n\n@media only screen and (max-width:480px) {\n    .Toastify__toast-container {\n        left: env(safe-area-inset-left);\n        margin: 0;\n        padding: 0;\n        width: 100vw\n    }\n    .Toastify__toast-container--top-center,\n    .Toastify__toast-container--top-left,\n    .Toastify__toast-container--top-right {\n        top: env(safe-area-inset-top);\n        transform: translateX(0)\n    }\n    .Toastify__toast-container--bottom-center,\n    .Toastify__toast-container--bottom-left,\n    .Toastify__toast-container--bottom-right {\n        bottom: env(safe-area-inset-bottom);\n        transform: translateX(0)\n    }\n    .Toastify__toast-container--rtl {\n        left: auto;\n        right: env(safe-area-inset-right)\n    }\n}\n\n.Toastify__toast {\n    --y: 0;\n    border-radius: 6px;\n    border-radius: var(--toastify-toast-bd-radius);\n    box-shadow: 0 4px 12px #0000001a;\n    box-sizing: border-box;\n    cursor: default;\n    direction: ltr;\n    display: flex;\n    font-family: sans-serif;\n    font-family: var(--toastify-font-family);\n    justify-content: space-between;\n    margin-bottom: 1rem;\n    max-height: 800px;\n    max-height: var(--toastify-toast-max-height);\n    min-height: 64px;\n    min-height: var(--toastify-toast-min-height);\n    overflow: hidden;\n    padding: 8px;\n    position: relative;\n    touch-action: none;\n    z-index: 0\n}\n\n.Toastify__toast--stacked {\n    position: absolute;\n    transform: translate3d(0, var(--y), 0) scale(var(--s));\n    transition: transform .3s;\n    width: 100%\n}\n\n.Toastify__toast--stacked[data-collapsed] .Toastify__close-button,\n.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body {\n    transition: opacity .1s\n}\n\n.Toastify__toast--stacked[data-collapsed=false] {\n    overflow: visible\n}\n\n.Toastify__toast--stacked[data-collapsed=true]:not(:last-child)>* {\n    opacity: 0\n}\n\n.Toastify__toast--stacked:after {\n    bottom: 100%;\n    content: \"\";\n    height: calc(var(--g)*1px);\n    left: 0;\n    position: absolute;\n    right: 0\n}\n\n.Toastify__toast--stacked[data-pos=top] {\n    top: 0\n}\n\n.Toastify__toast--stacked[data-pos=bot] {\n    bottom: 0\n}\n\n.Toastify__toast--stacked[data-pos=bot].Toastify__toast--stacked:before {\n    transform-origin: top\n}\n\n.Toastify__toast--stacked[data-pos=top].Toastify__toast--stacked:before {\n    transform-origin: bottom\n}\n\n.Toastify__toast--stacked:before {\n    bottom: 0;\n    content: \"\";\n    height: 100%;\n    left: 0;\n    position: absolute;\n    right: 0;\n    transform: scaleY(3);\n    z-index: -1\n}\n\n.Toastify__toast--rtl {\n    direction: rtl\n}\n\n.Toastify__toast--close-on-click {\n    cursor: pointer\n}\n\n.Toastify__toast-body {\n    align-items: center;\n    display: flex;\n    flex: 1 1 auto;\n    margin: auto 0;\n    padding: 6px\n}\n\n.Toastify__toast-body>div:last-child {\n    flex: 1 1;\n    word-break: break-word\n}\n\n.Toastify__toast-icon {\n    display: flex;\n    flex-shrink: 0;\n    margin-inline-end: 10px;\n    width: 20px\n}\n\n.Toastify--animate {\n    animation-duration: .5s;\n    animation-fill-mode: both\n}\n\n.Toastify--animate-icon {\n    animation-duration: .3s;\n    animation-fill-mode: both\n}\n\n@media only screen and (max-width:480px) {\n    .Toastify__toast {\n        border-radius: 0;\n        margin-bottom: 0\n    }\n}\n\n.Toastify__toast-theme--dark {\n    background: #121212;\n    background: var(--toastify-color-dark);\n    color: #fff;\n    color: var(--toastify-text-color-dark)\n}\n\n.Toastify__toast-theme--colored.Toastify__toast--default,\n.Toastify__toast-theme--light {\n    background: #fff;\n    background: var(--toastify-color-light);\n    color: #757575;\n    color: var(--toastify-text-color-light)\n}\n\n.Toastify__toast-theme--colored.Toastify__toast--info {\n    background: #3498db;\n    background: var(--toastify-color-info);\n    color: #fff;\n    color: var(--toastify-text-color-info)\n}\n\n.Toastify__toast-theme--colored.Toastify__toast--success {\n    background: #07bc0c;\n    background: var(--toastify-color-success);\n    color: #fff;\n    color: var(--toastify-text-color-success)\n}\n\n.Toastify__toast-theme--colored.Toastify__toast--warning {\n    background: #f1c40f;\n    background: var(--toastify-color-warning);\n    color: #fff;\n    color: var(--toastify-text-color-warning)\n}\n\n.Toastify__toast-theme--colored.Toastify__toast--error {\n    background: #e74c3c;\n    background: var(--toastify-color-error);\n    color: #fff;\n    color: var(--toastify-text-color-error)\n}\n\n.Toastify__progress-bar-theme--light {\n    background: linear-gradient(90deg, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);\n    background: var(--toastify-color-progress-light)\n}\n\n.Toastify__progress-bar-theme--dark {\n    background: #bb86fc;\n    background: var(--toastify-color-progress-dark)\n}\n\n.Toastify__progress-bar--info {\n    background: #3498db;\n    background: var(--toastify-color-progress-info)\n}\n\n.Toastify__progress-bar--success {\n    background: #07bc0c;\n    background: var(--toastify-color-progress-success)\n}\n\n.Toastify__progress-bar--warning {\n    background: #f1c40f;\n    background: var(--toastify-color-progress-warning)\n}\n\n.Toastify__progress-bar--error {\n    background: #e74c3c;\n    background: var(--toastify-color-progress-error)\n}\n\n.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error,\n.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,\n.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,\n.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning {\n    background: #ffffffb3;\n    background: var(--toastify-color-transparent)\n}\n\n.Toastify__close-button {\n    align-self: flex-start;\n    background: #0000;\n    border: none;\n    color: #fff;\n    cursor: pointer;\n    opacity: .7;\n    outline: none;\n    padding: 0;\n    transition: .3s ease;\n    z-index: 1\n}\n\n.Toastify__close-button--light {\n    color: #000;\n    opacity: .3\n}\n\n.Toastify__close-button>svg {\n    fill: currentColor;\n    height: 16px;\n    width: 14px\n}\n\n.Toastify__close-button:focus,\n.Toastify__close-button:hover {\n    opacity: 1\n}\n\n@keyframes Toastify__trackProgress {\n    0% {\n        transform: scaleX(1)\n    }\n    to {\n        transform: scaleX(0)\n    }\n}\n\n.Toastify__progress-bar {\n    border-bottom-left-radius: 6px;\n    border-bottom-left-radius: var(--toastify-toast-bd-radius);\n    bottom: 0;\n    height: 100%;\n    left: 0;\n    opacity: .7;\n    position: absolute;\n    transform-origin: left;\n    width: 100%;\n    z-index: 9999;\n    z-index: var(--toastify-z-index)\n}\n\n.Toastify__progress-bar--animated {\n    animation: Toastify__trackProgress linear 1 forwards\n}\n\n.Toastify__progress-bar--controlled {\n    transition: transform .2s\n}\n\n.Toastify__progress-bar--rtl {\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 6px;\n    border-bottom-right-radius: var(--toastify-toast-bd-radius);\n    left: auto;\n    right: 0;\n    transform-origin: right\n}\n\n.Toastify__progress-bar--wrp {\n    border-bottom-left-radius: 6px;\n    border-bottom-left-radius: var(--toastify-toast-bd-radius);\n    bottom: 0;\n    height: 5px;\n    left: 0;\n    position: absolute;\n    width: 100%\n}\n\n.Toastify__progress-bar--wrp[data-hidden=true] {\n    opacity: 0\n}\n\n.Toastify__progress-bar--bg {\n    height: 100%;\n    opacity: .2;\n    opacity: var(--toastify-color-progress-bgo);\n    width: 100%\n}\n\n.Toastify__spinner {\n    animation: Toastify__spin .65s linear infinite;\n    border: 2px solid #e0e0e0;\n    border-color: var(--toastify-spinner-color-empty-area);\n    border-radius: 100%;\n    border-right-color: #616161;\n    border-right-color: var(--toastify-spinner-color);\n    box-sizing: border-box;\n    height: 20px;\n    width: 20px\n}\n\n@keyframes Toastify__bounceInRight {\n    0%,\n    60%,\n    75%,\n    90%,\n    to {\n        animation-timing-function: cubic-bezier(.215, .61, .355, 1)\n    }\n    0% {\n        opacity: 0;\n        transform: translate3d(3000px, 0, 0)\n    }\n    60% {\n        opacity: 1;\n        transform: translate3d(-25px, 0, 0)\n    }\n    75% {\n        transform: translate3d(10px, 0, 0)\n    }\n    90% {\n        transform: translate3d(-5px, 0, 0)\n    }\n    to {\n        transform: none\n    }\n}\n\n@keyframes Toastify__bounceOutRight {\n    20% {\n        opacity: 1;\n        transform: translate3d(-20px, var(--y), 0)\n    }\n    to {\n        opacity: 0;\n        transform: translate3d(2000px, var(--y), 0)\n    }\n}\n\n@keyframes Toastify__bounceInLeft {\n    0%,\n    60%,\n    75%,\n    90%,\n    to {\n        animation-timing-function: cubic-bezier(.215, .61, .355, 1)\n    }\n    0% {\n        opacity: 0;\n        transform: translate3d(-3000px, 0, 0)\n    }\n    60% {\n        opacity: 1;\n        transform: translate3d(25px, 0, 0)\n    }\n    75% {\n        transform: translate3d(-10px, 0, 0)\n    }\n    90% {\n        transform: translate3d(5px, 0, 0)\n    }\n    to {\n        transform: none\n    }\n}\n\n@keyframes Toastify__bounceOutLeft {\n    20% {\n        opacity: 1;\n        transform: translate3d(20px, var(--y), 0)\n    }\n    to {\n        opacity: 0;\n        transform: translate3d(-2000px, var(--y), 0)\n    }\n}\n\n@keyframes Toastify__bounceInUp {\n    0%,\n    60%,\n    75%,\n    90%,\n    to {\n        animation-timing-function: cubic-bezier(.215, .61, .355, 1)\n    }\n    0% {\n        opacity: 0;\n        transform: translate3d(0, 3000px, 0)\n    }\n    60% {\n        opacity: 1;\n        transform: translate3d(0, -20px, 0)\n    }\n    75% {\n        transform: translate3d(0, 10px, 0)\n    }\n    90% {\n        transform: translate3d(0, -5px, 0)\n    }\n    to {\n        transform: translateZ(0)\n    }\n}\n\n@keyframes Toastify__bounceOutUp {\n    20% {\n        transform: translate3d(0, calc(var(--y) - 10px), 0)\n    }\n    40%,\n    45% {\n        opacity: 1;\n        transform: translate3d(0, calc(var(--y) + 20px), 0)\n    }\n    to {\n        opacity: 0;\n        transform: translate3d(0, -2000px, 0)\n    }\n}\n\n@keyframes Toastify__bounceInDown {\n    0%,\n    60%,\n    75%,\n    90%,\n    to {\n        animation-timing-function: cubic-bezier(.215, .61, .355, 1)\n    }\n    0% {\n        opacity: 0;\n        transform: translate3d(0, -3000px, 0)\n    }\n    60% {\n        opacity: 1;\n        transform: translate3d(0, 25px, 0)\n    }\n    75% {\n        transform: translate3d(0, -10px, 0)\n    }\n    90% {\n        transform: translate3d(0, 5px, 0)\n    }\n    to {\n        transform: none\n    }\n}\n\n@keyframes Toastify__bounceOutDown {\n    20% {\n        transform: translate3d(0, calc(var(--y) - 10px), 0)\n    }\n    40%,\n    45% {\n        opacity: 1;\n        transform: translate3d(0, calc(var(--y) + 20px), 0)\n    }\n    to {\n        opacity: 0;\n        transform: translate3d(0, 2000px, 0)\n    }\n}\n\n.Toastify__bounce-enter--bottom-left,\n.Toastify__bounce-enter--top-left {\n    animation-name: Toastify__bounceInLeft\n}\n\n.Toastify__bounce-enter--bottom-right,\n.Toastify__bounce-enter--top-right {\n    animation-name: Toastify__bounceInRight\n}\n\n.Toastify__bounce-enter--top-center {\n    animation-name: Toastify__bounceInDown\n}\n\n.Toastify__bounce-enter--bottom-center {\n    animation-name: Toastify__bounceInUp\n}\n\n.Toastify__bounce-exit--bottom-left,\n.Toastify__bounce-exit--top-left {\n    animation-name: Toastify__bounceOutLeft\n}\n\n.Toastify__bounce-exit--bottom-right,\n.Toastify__bounce-exit--top-right {\n    animation-name: Toastify__bounceOutRight\n}\n\n.Toastify__bounce-exit--top-center {\n    animation-name: Toastify__bounceOutUp\n}\n\n.Toastify__bounce-exit--bottom-center {\n    animation-name: Toastify__bounceOutDown\n}\n\n@keyframes Toastify__zoomIn {\n    0% {\n        opacity: 0;\n        transform: scale3d(.3, .3, .3)\n    }\n    50% {\n        opacity: 1\n    }\n}\n\n@keyframes Toastify__zoomOut {\n    0% {\n        opacity: 1\n    }\n    50% {\n        opacity: 0;\n        transform: translate3d(0, var(--y), 0) scale3d(.3, .3, .3)\n    }\n    to {\n        opacity: 0\n    }\n}\n\n.Toastify__zoom-enter {\n    animation-name: Toastify__zoomIn\n}\n\n.Toastify__zoom-exit {\n    animation-name: Toastify__zoomOut\n}\n\n@keyframes Toastify__flipIn {\n    0% {\n        animation-timing-function: ease-in;\n        opacity: 0;\n        transform: perspective(400px) rotateX(90deg)\n    }\n    40% {\n        animation-timing-function: ease-in;\n        transform: perspective(400px) rotateX(-20deg)\n    }\n    60% {\n        opacity: 1;\n        transform: perspective(400px) rotateX(10deg)\n    }\n    80% {\n        transform: perspective(400px) rotateX(-5deg)\n    }\n    to {\n        transform: perspective(400px)\n    }\n}\n\n@keyframes Toastify__flipOut {\n    0% {\n        transform: translate3d(0, var(--y), 0) perspective(400px)\n    }\n    30% {\n        opacity: 1;\n        transform: translate3d(0, var(--y), 0) perspective(400px) rotateX(-20deg)\n    }\n    to {\n        opacity: 0;\n        transform: translate3d(0, var(--y), 0) perspective(400px) rotateX(90deg)\n    }\n}\n\n.Toastify__flip-enter {\n    animation-name: Toastify__flipIn\n}\n\n.Toastify__flip-exit {\n    animation-name: Toastify__flipOut\n}\n\n@keyframes Toastify__slideInRight {\n    0% {\n        transform: translate3d(110%, 0, 0);\n        visibility: visible\n    }\n    to {\n        transform: translate3d(0, var(--y), 0)\n    }\n}\n\n@keyframes Toastify__slideInLeft {\n    0% {\n        transform: translate3d(-110%, 0, 0);\n        visibility: visible\n    }\n    to {\n        transform: translate3d(0, var(--y), 0)\n    }\n}\n\n@keyframes Toastify__slideInUp {\n    0% {\n        transform: translate3d(0, 110%, 0);\n        visibility: visible\n    }\n    to {\n        transform: translate3d(0, var(--y), 0)\n    }\n}\n\n@keyframes Toastify__slideInDown {\n    0% {\n        transform: translate3d(0, -110%, 0);\n        visibility: visible\n    }\n    to {\n        transform: translate3d(0, var(--y), 0)\n    }\n}\n\n@keyframes Toastify__slideOutRight {\n    0% {\n        transform: translate3d(0, var(--y), 0)\n    }\n    to {\n        transform: translate3d(110%, var(--y), 0);\n        visibility: hidden\n    }\n}\n\n@keyframes Toastify__slideOutLeft {\n    0% {\n        transform: translate3d(0, var(--y), 0)\n    }\n    to {\n        transform: translate3d(-110%, var(--y), 0);\n        visibility: hidden\n    }\n}\n\n@keyframes Toastify__slideOutDown {\n    0% {\n        transform: translate3d(0, var(--y), 0)\n    }\n    to {\n        transform: translate3d(0, 500px, 0);\n        visibility: hidden\n    }\n}\n\n@keyframes Toastify__slideOutUp {\n    0% {\n        transform: translate3d(0, var(--y), 0)\n    }\n    to {\n        transform: translate3d(0, -500px, 0);\n        visibility: hidden\n    }\n}\n\n.Toastify__slide-enter--bottom-left,\n.Toastify__slide-enter--top-left {\n    animation-name: Toastify__slideInLeft\n}\n\n.Toastify__slide-enter--bottom-right,\n.Toastify__slide-enter--top-right {\n    animation-name: Toastify__slideInRight\n}\n\n.Toastify__slide-enter--top-center {\n    animation-name: Toastify__slideInDown\n}\n\n.Toastify__slide-enter--bottom-center {\n    animation-name: Toastify__slideInUp\n}\n\n.Toastify__slide-exit--bottom-left,\n.Toastify__slide-exit--top-left {\n    animation-duration: .3s;\n    animation-name: Toastify__slideOutLeft;\n    animation-timing-function: ease-in\n}\n\n.Toastify__slide-exit--bottom-right,\n.Toastify__slide-exit--top-right {\n    animation-duration: .3s;\n    animation-name: Toastify__slideOutRight;\n    animation-timing-function: ease-in\n}\n\n.Toastify__slide-exit--top-center {\n    animation-duration: .3s;\n    animation-name: Toastify__slideOutUp;\n    animation-timing-function: ease-in\n}\n\n.Toastify__slide-exit--bottom-center {\n    animation-duration: .3s;\n    animation-name: Toastify__slideOutDown;\n    animation-timing-function: ease-in\n}\n\n@keyframes Toastify__spin {\n    0% {\n        transform: rotate(0deg)\n    }\n    to {\n        transform: rotate(1turn)\n    }\n}\n\n/*# sourceMappingURL=main.3edfef36.css.map*/\n\n/* V0 check-in redesign tokens and components */\n:root {\n    --v0-navy: #1b3a6b;\n    --v0-navy-light: #2a4f8e;\n    --v0-success: #22c55e;\n    --v0-success-light: #dcfce7;\n    --v0-upload-bg: #eff6ff;\n    --v0-upload-border: #93c5fd;\n    --v0-background: #f8fafc;\n    --v0-card: #ffffff;\n    --v0-secondary: #f1f5f9;\n    --v0-muted: #64748b;\n    --v0-border: #e2e8f0;\n}\n\nbody {\n    background: var(--v0-background);\n}\n\n.v0-shell {\n    display: flex;\n    flex-direction: column;\n    min-height: 100dvh;\n    max-width: 430px;\n    margin: 0 auto;\n    background: var(--v0-background);\n}\n\n.v0-top-bar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    min-height: 56px;\n    padding: 12px 20px;\n    background: #fff;\n    border-bottom: 1px solid var(--v0-border);\n}\n\n.v0-brand,\n.v0-secure-badge {\n    display: flex;\n    align-items: center;\n}\n\n.v0-top-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.v0-brand {\n    gap: 8px;\n    color: var(--v0-navy);\n    font-size: 14px;\n    font-weight: 700;\n    letter-spacing: -0.01em;\n}\n\n.v0-brand-mark {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 36px;\n    height: 36px;\n    border-radius: 10px;\n    background: var(--v0-navy);\n    color: #fff;\n    font-size: 12px;\n    font-weight: 800;\n}\n\n.v0-secure-badge {\n    gap: 6px;\n    padding: 6px 12px;\n    border: 1px solid var(--v0-upload-border);\n    border-radius: 999px;\n    background: var(--v0-upload-bg);\n    color: var(--v0-navy);\n    font-size: 12px;\n    font-weight: 700;\n}\n\n.v0-language-switch {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n}\n\n.v0-language-options {\n    display: inline-flex;\n    gap: 2px;\n    padding: 2px;\n    border: 1px solid var(--v0-border);\n    border-radius: 9px;\n    background: var(--v0-secondary);\n}\n\n.v0-language-button {\n    min-width: 34px;\n    min-height: 30px;\n    padding: 4px 8px;\n    border: 0;\n    border-radius: 7px;\n    background: transparent;\n    color: var(--v0-muted);\n    font: inherit;\n    font-size: 11px;\n    font-weight: 800;\n    line-height: 1;\n    cursor: pointer;\n}\n\n.v0-language-button[aria-pressed=\"true\"] {\n    background: var(--v0-navy);\n    color: #fff;\n    box-shadow: 0 1px 3px rgba(27, 58, 107, 0.22);\n}\n\n.v0-language-button:focus-visible {\n    outline: 2px solid var(--v0-navy-light);\n    outline-offset: 2px;\n}\n\n.v0-language-message {\n    display: none;\n    width: 190px;\n    margin-top: 5px;\n    color: #92400e;\n    font-size: 11px;\n    font-weight: 700;\n    line-height: 1.35;\n    text-align: right;\n}\n\n.v0-language-message.is-visible {\n    display: block;\n}\n\n.v0-language-switch--top .v0-language-message {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    z-index: 20;\n    padding: 8px 10px;\n    border: 1px solid #fcd34d;\n    border-radius: 9px;\n    background: #fef3c7;\n    box-shadow: 0 4px 14px rgba(146, 64, 14, 0.14);\n}\n\n.v0-main-card {\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    overflow: hidden;\n    margin: 12px;\n    border-radius: 20px;\n    background: var(--v0-card);\n    box-shadow: 0 4px 24px rgba(27, 58, 107, 0.1), 0 1px 4px rgba(27, 58, 107, 0.06);\n}\n\n.v0-card-scroll {\n    flex: 1;\n    overflow-y: auto;\n    padding: 16px;\n}\n\n.v0-card-stack {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.v0-section-label {\n    margin: 0 0 8px;\n    color: var(--v0-muted);\n    font-size: 11px;\n    font-weight: 800;\n    letter-spacing: 0.08em;\n    line-height: 1.2;\n    text-transform: uppercase;\n}\n\n.v0-hero-copy {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.v0-hero-copy h1 {\n    margin: 0;\n    color: var(--v0-navy);\n    font-size: 24px;\n    font-weight: 800;\n    letter-spacing: -0.03em;\n}\n\n.v0-hero-copy p {\n    margin: 0;\n    color: var(--v0-muted);\n    font-size: 13px;\n    line-height: 1.5;\n}\n\n.v0-upload-wrapper {\n    position: relative;\n}\n\n.v0-upload-zone {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 180px;\n    overflow: hidden;\n    border: 2px dashed var(--v0-upload-border);\n    border-radius: 18px;\n    background: var(--v0-upload-bg);\n    color: var(--v0-navy);\n    cursor: pointer;\n    transition: border-color 0.2s ease, background 0.2s ease, transform 0.2s ease;\n}\n\n.v0-upload-zone:hover {\n    transform: translateY(-1px);\n    border-color: var(--v0-navy-light);\n}\n\n.v0-upload-zone.is-uploading,\n.v0-upload-zone.is-verified {\n    cursor: default;\n}\n\n.v0-upload-zone.is-verified {\n    border-color: var(--v0-success);\n    background: var(--v0-success-light);\n}\n\n.v0-upload-state {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    padding: 24px;\n    text-align: center;\n    animation: v0-fade-in 0.25s ease-out;\n}\n\n.v0-upload-icon {\n    display: inline-flex;\n    color: var(--v0-navy);\n}\n\n.v0-upload-title {\n    margin: 0;\n    color: var(--v0-navy);\n    font-size: 18px;\n    font-weight: 800;\n    line-height: 1.2;\n}\n\n.v0-upload-copy,\n.v0-upload-file {\n    margin: 0;\n    color: var(--v0-muted);\n    font-size: 13px;\n    line-height: 1.4;\n}\n\n.v0-upload-file {\n    max-width: 240px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.v0-preview-wrap {\n    position: relative;\n    width: 80px;\n    height: 80px;\n}\n\n.v0-preview {\n    width: 80px;\n    height: 80px;\n    object-fit: cover;\n    border: 1px solid var(--v0-border);\n    border-radius: 12px;\n    box-shadow: 0 6px 18px rgba(15, 23, 42, 0.12);\n}\n\n.v0-selfie-camera.is-selfie-live {\n    min-height: 220px;\n    cursor: default;\n}\n\n.v0-selfie-camera.is-selfie-live:hover {\n    transform: none;\n}\n\n.v0-selfie-live-inner {\n    padding: 12px;\n}\n\n.v0-selfie-video {\n    width: 100%;\n    max-width: 360px;\n    max-height: 240px;\n    border-radius: 14px;\n    background: #0f172a;\n    object-fit: contain;\n}\n\n.v0-selfie-preview-wrap {\n    width: auto;\n    height: auto;\n    max-width: 120px;\n}\n\n.v0-selfie-preview {\n    width: 96px;\n    height: 96px;\n}\n\n.v0-selfie-actions {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n    width: 100%;\n    max-width: 360px;\n}\n\n.v0-selfie-actions-row {\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n}\n\n.v0-selfie-capture-btn {\n    flex: 1;\n    min-height: 48px;\n    animation: none;\n}\n\n.v0-selfie-capture-btn:not(:disabled) {\n    animation: none;\n}\n\n.v0-selfie-camera.is-selfie-idle-clickable {\n    cursor: pointer;\n}\n\n.v0-selfie-camera.is-selfie-idle-clickable:hover {\n    transform: translateY(-1px);\n    border-color: var(--v0-navy-light);\n}\n\n.v0-selfie-camera.is-selfie-idle-disabled {\n    cursor: not-allowed;\n    opacity: 0.75;\n}\n\n.v0-primary-button.v0-selfie-open-pill {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    line-height: 1;\n    box-sizing: border-box;\n    min-height: 52px;\n    padding: 0 1.25rem;\n    pointer-events: none;\n    user-select: none;\n}\n\n.v0-check-bubble,\n.v0-success-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--v0-success);\n}\n\n.v0-check-bubble {\n    position: absolute;\n    top: -8px;\n    right: -8px;\n    width: 26px;\n    height: 26px;\n    border-radius: 999px;\n    background: #fff;\n    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.14);\n}\n\n.v0-spinner {\n    width: 38px;\n    height: 38px;\n    border: 3px solid rgba(27, 58, 107, 0.18);\n    border-top-color: var(--v0-navy);\n    border-radius: 999px;\n    animation: v0-spin 0.8s linear infinite;\n}\n\n.v0-consent {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.v0-consent-heading-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 8px;\n}\n\n.v0-consent-heading-row .v0-section-label {\n    margin-bottom: 0;\n}\n\n@media (max-width: 380px) {\n    .v0-top-bar {\n        padding-inline: 12px;\n    }\n\n    .v0-secure-badge span {\n        display: none;\n    }\n\n    .v0-secure-badge {\n        padding-inline: 8px;\n    }\n}\n\n.v0-page-error-banner {\n    display: flex;\n    align-items: flex-start;\n    gap: 14px;\n    margin: 0 0 20px;\n    padding: 16px 18px;\n    border-radius: 14px;\n    border: 1px solid #d5dee2;\n    background: #f5f8f9;\n}\n\n.v0-page-error-icon {\n    flex: 0 0 auto;\n    color: #52636d;\n    line-height: 1;\n    margin-top: 2px;\n}\n\n.v0-page-error-text {\n    margin: 0;\n    flex: 1;\n    color: #34454f;\n    font-size: 15px;\n    font-weight: 400;\n    line-height: 1.45;\n}\n\n.v0-page-success-banner {\n    display: flex;\n    align-items: flex-start;\n    gap: 14px;\n    margin: 0 0 20px;\n    padding: 16px 18px;\n    border-radius: 14px;\n    border: 1px solid rgba(22, 101, 52, 0.32);\n    background: linear-gradient(135deg, #ecfdf3 0%, #f0fdf4 100%);\n    box-shadow: 0 4px 18px rgba(22, 101, 52, 0.12);\n}\n\n.v0-page-success-icon {\n    flex: 0 0 auto;\n    color: #15803d;\n    line-height: 1;\n    margin-top: 2px;\n}\n\n.v0-page-success-copy {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    min-width: 0;\n}\n\n.v0-page-success-text {\n    margin: 0;\n    color: #14532d;\n    font-size: 15px;\n    font-weight: 600;\n    line-height: 1.45;\n}\n\n.v0-page-success-detail {\n    margin: 0;\n    color: #166534;\n    font-size: 15px;\n    font-weight: 500;\n    line-height: 1.45;\n}\n\n.v0-page-success-text--secondary {\n    font-weight: 500;\n    color: #166534;\n}\n\n.v0-agreement-box {\n    border: none;\n    background: transparent;\n    overflow: visible;\n}\n\n.v0-agreement-panel-loading,\n.v0-agreement-panel {\n    border-radius: 12px;\n    padding: 12px;\n    font-size: 13px;\n    line-height: 1.625;\n    overflow-y: auto;\n    overflow-x: hidden;\n    max-height: 72px;\n    background: var(--v0-secondary);\n    color: var(--v0-muted);\n    border: 1px solid var(--v0-border);\n    -webkit-overflow-scrolling: touch;\n}\n\n.v0-agreement-summary-title {\n    margin: 0 0 2px;\n    padding: 0;\n    font-weight: 600;\n    font-size: 13px;\n    color: var(--v0-navy);\n}\n\n.v0-agreement-body {\n    margin: 0 0 6px;\n    color: var(--v0-muted);\n    font-size: 13px;\n    line-height: 1.625;\n}\n\n.v0-agreement-body:last-child {\n    margin-bottom: 0;\n}\n\n.v0-agreement-panel-loading {\n    margin: 0;\n    max-height: none;\n}\n\n.v0-agreement-status {\n    margin: 0;\n    padding: 14px 16px;\n    font-size: 14px;\n    color: var(--v0-muted);\n}\n\n.v0-agreement-status--error {\n    color: #b91c1c;\n    font-weight: 600;\n}\n\n.v0-legal-notice {\n    border: 1px solid var(--v0-border);\n    border-radius: 12px;\n    background: var(--v0-secondary);\n    color: var(--v0-muted);\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n    padding: 12px;\n}\n\n.v0-legal-notice svg {\n    flex: 0 0 auto;\n    margin-top: 2px;\n}\n\n.v0-legal-notice p {\n    margin: 0;\n    font-size: 11px;\n    line-height: 1.45;\n}\n\n.v0-consent-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    min-height: 44px;\n    margin: 0;\n    cursor: pointer;\n    opacity: 1;\n    transition: opacity 0.2s ease;\n}\n\n.v0-consent-row.is-disabled {\n    pointer-events: none;\n    opacity: 0.45;\n}\n\n.v0-checkbox {\n    position: relative;\n    flex: 0 0 auto;\n    width: 28px;\n    height: 28px;\n}\n\n.v0-checkbox input {\n    position: absolute;\n    inset: 0;\n    width: 28px;\n    height: 28px;\n    opacity: 0;\n    cursor: pointer;\n}\n\n.v0-checkbox-visual {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    border: 2px solid var(--v0-border);\n    border-radius: 8px;\n    background: #fff;\n    color: #fff;\n    transition: background 0.2s ease, border-color 0.2s ease;\n}\n\n.v0-checkbox input:checked + .v0-checkbox-visual {\n    border-color: var(--v0-navy);\n    background: var(--v0-navy);\n}\n\n.v0-consent-text {\n    color: var(--v0-navy);\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 1.35;\n}\n\n.v0-consent-text a {\n    color: var(--v0-navy-light);\n    text-decoration: underline;\n}\n\n.v0-inline-hint-wrap {\n    overflow: hidden;\n}\n\n.v0-inline-hint {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    max-height: 0;\n    overflow: hidden;\n    padding: 0 12px;\n    border: 1px solid transparent;\n    border-radius: 12px;\n    background: #fef3c7;\n    color: #92400e;\n    font-size: 13px;\n    font-weight: 600;\n    line-height: 1.35;\n    opacity: 0;\n    transition: max-height 0.25s ease, opacity 0.25s ease, padding 0.25s ease, border-color 0.25s ease;\n}\n\n.v0-inline-hint.is-visible {\n    max-height: 120px;\n    padding: 10px 12px;\n    border-color: #fcd34d;\n    opacity: 1;\n}\n\n.v0-sticky-footer {\n    padding: 12px 16px 20px;\n    border-top: 1px solid var(--v0-border);\n    background: #fff;\n}\n\n.v0-primary-button {\n    width: 100%;\n    min-height: 52px;\n    border: 0;\n    border-radius: 18px;\n    background: var(--v0-navy);\n    color: #fff;\n    font-size: 16px;\n    font-weight: 800;\n    cursor: pointer;\n    transition: opacity 0.2s ease, transform 0.2s ease;\n}\n\n.v0-primary-button:not(:disabled) {\n    animation: v0-pulse-btn 1.5s ease-in-out infinite;\n}\n\n.v0-primary-button:hover:not(:disabled) {\n    transform: translateY(-1px);\n}\n\n.v0-primary-button:disabled {\n    background: var(--v0-muted);\n    cursor: not-allowed;\n    opacity: 0.55;\n}\n\n.v0-review-form {\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n}\n\n.v0-member-card {\n    padding: 16px;\n    border: 1px solid var(--v0-border);\n    border-radius: 18px;\n    background: #fff;\n    box-shadow: 0 1px 8px rgba(15, 23, 42, 0.04);\n}\n\n.v0-member-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 12px;\n}\n\n.v0-member-title {\n    margin: 0;\n    color: var(--v0-navy);\n    font-size: 18px;\n    font-weight: 800;\n}\n\n.v0-ghost-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    min-height: 36px;\n    padding: 7px 12px;\n    border: 1px solid var(--v0-border);\n    border-radius: 999px;\n    background: var(--v0-secondary);\n    color: var(--v0-navy);\n    font-size: 13px;\n    font-weight: 800;\n    cursor: pointer;\n}\n\n.v0-ghost-button.danger {\n    color: #b91c1c;\n}\n\n.v0-two-col {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n}\n\n.v0-field-row {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 12px;\n}\n\n.v0-add-guest {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n    padding: 16px;\n    border: 1px dashed var(--v0-upload-border);\n    border-radius: 18px;\n    background: var(--v0-upload-bg);\n    color: var(--v0-muted);\n    text-align: center;\n    font-size: 13px;\n}\n\n.v0-add-guest .v0-ghost-button {\n    background: #fff;\n}\n\n.v0-not-found-panel {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n    padding: 24px 12px 32px;\n    text-align: center;\n}\n\n.v0-not-found-badge {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 64px;\n    height: 64px;\n    border-radius: 999px;\n    background: #fffbeb;\n    border: 1px solid #fde68a;\n    color: #b45309;\n}\n\n.v0-not-found-code {\n    margin: 0;\n    color: var(--v0-navy);\n    font-size: 52px;\n    font-weight: 800;\n    letter-spacing: -0.06em;\n    line-height: 1;\n}\n\n.v0-not-found-copy {\n    align-items: center;\n    max-width: 320px;\n}\n\n.v0-not-found-copy h1 {\n    font-size: 22px;\n    line-height: 1.25;\n}\n\n.v0-not-found-copy p {\n    font-size: 14px;\n    line-height: 1.55;\n}\n\n.v0-not-found-retry {\n    max-width: 240px;\n}\n\n.v0-expired-panel .v0-not-found-badge {\n    background: #eff6ff;\n    border-color: var(--v0-upload-border);\n    color: var(--v0-navy);\n}\n\n.v0-inline-error {\n    padding: 12px 14px;\n    border-radius: 14px;\n    border: 1px solid #fecaca;\n    background: #fef2f2;\n    color: #991b1b;\n    font-size: 14px;\n    line-height: 1.45;\n}\n\n.v0-success-panel {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 14px;\n    padding: 32px 20px;\n    color: #166534;\n    text-align: center;\n}\n\n.v0-success-panel h4 {\n    margin: 0;\n    color: #15803d;\n    font-size: 22px;\n    font-weight: 800;\n}\n\n.v0-success-panel p {\n    margin: 0;\n    color: #166534;\n    font-size: 15px;\n    line-height: 1.5;\n}\n\n.v0-success-badge {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 70px;\n    height: 70px;\n    border-radius: 999px;\n    background: var(--v0-success-light);\n    color: var(--v0-success);\n}\n\n.v0-modal-content {\n    max-width: 380px;\n    width: calc(100% - 32px);\n    margin: 25vh auto auto;\n    border: 0;\n    border-radius: 20px;\n    box-shadow: 0 20px 50px rgba(15, 23, 42, 0.25);\n}\n\n.v0-modal-actions {\n    justify-content: center;\n    gap: 12px;\n}\n\n@keyframes v0-spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes v0-pulse-btn {\n    0%, 100% {\n        box-shadow: 0 0 0 0 rgba(27, 58, 107, 0.4);\n    }\n    50% {\n        box-shadow: 0 0 0 8px rgba(27, 58, 107, 0);\n    }\n}\n\n@keyframes v0-fade-in {\n    from {\n        opacity: 0;\n        transform: translateY(6px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@media (max-width: 600px) {\n    .v0-main-card {\n        margin: 12px;\n    }\n\n    .v0-two-col {\n        grid-template-columns: 1fr;\n        gap: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
